webpackJsonp([1,2],[
/* 0 */,
/* 1 */,
/* 2 */,
/* 3 */,
/* 4 */,
/* 5 */,
/* 6 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(253)

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(171),
  /* template */
  __webpack_require__(297),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 7 */,
/* 8 */,
/* 9 */,
/* 10 */,
/* 11 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(249)

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(172),
  /* template */
  __webpack_require__(293),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 12 */,
/* 13 */,
/* 14 */,
/* 15 */,
/* 16 */,
/* 17 */,
/* 18 */,
/* 19 */,
/* 20 */,
/* 21 */,
/* 22 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__ = __webpack_require__(192);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_lodash__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_moment__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_moment__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__helpers_bootstrap__ = __webpack_require__(161);






var bsSocialNetwork = __WEBPACK_IMPORTED_MODULE_4__helpers_bootstrap__["a" /* default */].generateSocialNetwork();
var bsCuratedContent = __WEBPACK_IMPORTED_MODULE_4__helpers_bootstrap__["a" /* default */].generateCuratedContent({
  profileIds: bsSocialNetwork.profileIds
});
var bsChats = __WEBPACK_IMPORTED_MODULE_4__helpers_bootstrap__["a" /* default */].generateChats({
  profileIds: bsSocialNetwork.profileIds
});
var meUserId = __WEBPACK_IMPORTED_MODULE_2_lodash___default.a.sample(bsSocialNetwork.profiles).profileId;
console.log('api:meUserId', meUserId, bsSocialNetwork, bsCuratedContent, bsChats);

function realUserId(meOrUserId) {
  var userId = meOrUserId === 'me' ? meUserId : meOrUserId;
  return userId;
}

function envelope(data) {
  var meta = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : { code: 200 };
  var pagination = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};

  return {
    data: data,
    meta: meta,
    pagination: pagination
  };
}

function isThisUserFollowingThatUser(thisUserId, thatUserId) {
  var followeeIds = bsSocialNetwork.relationships[thisUserId].followeeIds;
  return followeeIds.indexOf(thatUserId) !== -1;
}

function isMeUserFollowingUser(userId) {
  return isThisUserFollowingThatUser(meUserId, userId);
}

function userIdsFollowingThisUser(userId) {
  return bsSocialNetwork.relationships[userId].followeeIds;
}

function userIdsFollowedByThisUser(userId) {
  var networkUserIdList = __WEBPACK_IMPORTED_MODULE_2_lodash___default.a.keys(bsSocialNetwork.relationships);
  return __WEBPACK_IMPORTED_MODULE_2_lodash___default.a.filter(networkUserIdList, function (followerId) {
    return isThisUserFollowingThatUser(followerId, userId);
  });
}

function getUserById(iUserId) {
  var userId = realUserId(iUserId);
  var user = bsSocialNetwork.profiles[userId];
  var stats = {
    item: __WEBPACK_IMPORTED_MODULE_2_lodash___default.a.size(bsCuratedContent.contents[userId].items),
    collection: __WEBPACK_IMPORTED_MODULE_2_lodash___default.a.size(bsCuratedContent.contents[userId].collections),
    followee: __WEBPACK_IMPORTED_MODULE_2_lodash___default.a.size(userIdsFollowingThisUser(userId)),
    follower: __WEBPACK_IMPORTED_MODULE_2_lodash___default.a.size(userIdsFollowedByThisUser(userId))
  };
  var isFollowed = isMeUserFollowingUser(userId) || false;
  var isMe = userId === meUserId;
  var result = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, user, {
    isFollowed: isFollowed,
    isMe: isMe,
    stats: stats,
    counts: stats
  });
  return envelope(result);
}

function getFollowingList(iUserId) {
  var userId = realUserId(iUserId);
  var followeeIds = bsSocialNetwork.relationships[userId].followeeIds;
  var followingList = __WEBPACK_IMPORTED_MODULE_2_lodash___default.a.map(followeeIds, function (followeeId) {
    var followee = getUserById(followeeId).data;
    return followee;
  });
  var result = followingList;
  return envelope(result);
}

function getFollowersList(iUserId) {
  var userId = realUserId(iUserId);

  var followerIds = userIdsFollowedByThisUser(userId);
  var followerList = __WEBPACK_IMPORTED_MODULE_2_lodash___default.a.map(followerIds, function (followerId) {
    var follower = getUserById(followerId).data;
    return follower;
  });

  var result = followerList;
  return envelope(result);
}

function followUser(iUserId) {
  var userId = realUserId(iUserId);
  var followeeIds = bsSocialNetwork.relationships[meUserId].followeeIds;
  var updated = __WEBPACK_IMPORTED_MODULE_2_lodash___default.a.uniq(__WEBPACK_IMPORTED_MODULE_2_lodash___default.a.concat(followeeIds, [userId]));
  bsSocialNetwork.relationships[meUserId].followeeIds = updated;

  var result = getUserById(userId).data;
  return envelope(result);
}

function unfollowUser(iUserId) {
  var userId = realUserId(iUserId);
  var followeeIds = bsSocialNetwork.relationships[meUserId].followeeIds;
  var updated = __WEBPACK_IMPORTED_MODULE_2_lodash___default.a.reject(followeeIds, function (followeeId) {
    return followeeId === userId;
  });
  bsSocialNetwork.relationships[meUserId].followeeIds = updated;

  var result = getUserById(userId).data;
  return envelope(result);
}

function getContentByUserId(iUserId) {
  var userId = realUserId(iUserId);
  var items = bsCuratedContent.contents[userId].items;
  var result = items;
  return envelope(result);
}

function getCollectionsByUserId(iUserId) {
  var userId = realUserId(iUserId);
  var items = bsCuratedContent.contents[userId].items;
  var itemMap = __WEBPACK_IMPORTED_MODULE_2_lodash___default.a.keyBy(items, 'itemId');
  var collections = bsCuratedContent.contents[userId].collections;

  var result = __WEBPACK_IMPORTED_MODULE_2_lodash___default.a.map(collections, function (collection) {
    var normalisedItems = __WEBPACK_IMPORTED_MODULE_2_lodash___default.a.map(collection.itemIds, function (itemId) {
      return itemMap[itemId];
    });
    return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, __WEBPACK_IMPORTED_MODULE_2_lodash___default.a.omit(collection, 'itemIds'), {
      counts: {
        items: __WEBPACK_IMPORTED_MODULE_2_lodash___default.a.size(normalisedItems)
      },
      items: normalisedItems
    });
  });
  return envelope(result);
}

function normaliseChatMessage(chatMessage) {
  return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, chatMessage, {
    person: getUserById(chatMessage.ownerProfileId).data
  });
}

function getChatRoomById(chatRoomId) {
  var chatRoom = bsChats.chatRooms[chatRoomId];

  var result = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, chatRoom, {
    messages: __WEBPACK_IMPORTED_MODULE_2_lodash___default.a.map(chatRoom.messages, function (message) {
      return normaliseChatMessage(message);
    }),
    participants: __WEBPACK_IMPORTED_MODULE_2_lodash___default.a.map(chatRoom.participants, function (userId) {
      return getUserById(userId).data;
    })
  });
  return envelope(result);
}

function getChatRooms() {
  var chatRoomList = __WEBPACK_IMPORTED_MODULE_2_lodash___default.a.map(bsChats.chatRooms, function (rawChatRoom, chatRoomId) {
    var chatRoom = getChatRoomById(chatRoomId).data;

    return {
      chatRoomId: chatRoomId,
      title: chatRoom.title,
      counts: {
        messages: __WEBPACK_IMPORTED_MODULE_2_lodash___default.a.size(chatRoom.messages),
        participants: __WEBPACK_IMPORTED_MODULE_2_lodash___default.a.size(chatRoom.participants)
      },
      preview: __WEBPACK_IMPORTED_MODULE_2_lodash___default.a.last(chatRoom.messages)
    };
  });
  var result = chatRoomList;
  return envelope(result);
}

function sendMessageToChatRoom(_ref) {
  var chatRoomId = _ref.chatRoomId,
      userId = _ref.userId,
      message = _ref.message;

  var chatRoom = bsChats.chatRooms[chatRoomId];
  var chatMessage = {
    messageId: __WEBPACK_IMPORTED_MODULE_2_lodash___default.a.uniqueId('cm'),
    ownerProfileId: realUserId(userId),
    timestamp: __WEBPACK_IMPORTED_MODULE_3_moment___default()().unix(),
    content: message
  };
  chatRoom.messages.push(chatMessage);
  var result = normaliseChatMessage(chatMessage);
  return envelope(result);
}

var AJAX_SIMULATION_DELAY_MS = 0;
function promiseApi(fn) {
  return function (args) {
    return new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a(function (resolve) {
      setTimeout(function () {
        resolve(fn(args));
      }, AJAX_SIMULATION_DELAY_MS);
    });
  };
}

/* harmony default export */ __webpack_exports__["a"] = {
  getUserById: promiseApi(getUserById),
  getFollowingList: promiseApi(getFollowingList),
  getFollowersList: promiseApi(getFollowersList),
  followUser: promiseApi(followUser),
  unfollowUser: promiseApi(unfollowUser),
  getContentByUserId: promiseApi(getContentByUserId),
  getCollectionsByUserId: promiseApi(getCollectionsByUserId),
  getChatRooms: promiseApi(getChatRooms),
  getChatRoomById: promiseApi(getChatRoomById),
  sendMessageToChatRoom: promiseApi(sendMessageToChatRoom)
};

/***/ }),
/* 23 */,
/* 24 */,
/* 25 */,
/* 26 */,
/* 27 */,
/* 28 */,
/* 29 */,
/* 30 */,
/* 31 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(252)

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(187),
  /* template */
  __webpack_require__(296),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 32 */,
/* 33 */,
/* 34 */,
/* 35 */,
/* 36 */,
/* 37 */,
/* 38 */,
/* 39 */,
/* 40 */,
/* 41 */,
/* 42 */,
/* 43 */,
/* 44 */,
/* 45 */,
/* 46 */,
/* 47 */,
/* 48 */,
/* 49 */,
/* 50 */,
/* 51 */,
/* 52 */,
/* 53 */,
/* 54 */,
/* 55 */,
/* 56 */,
/* 57 */,
/* 58 */,
/* 59 */,
/* 60 */,
/* 61 */,
/* 62 */,
/* 63 */,
/* 64 */,
/* 65 */,
/* 66 */,
/* 67 */,
/* 68 */,
/* 69 */,
/* 70 */,
/* 71 */,
/* 72 */,
/* 73 */,
/* 74 */,
/* 75 */,
/* 76 */,
/* 77 */,
/* 78 */,
/* 79 */,
/* 80 */,
/* 81 */,
/* 82 */,
/* 83 */,
/* 84 */,
/* 85 */,
/* 86 */,
/* 87 */,
/* 88 */,
/* 89 */,
/* 90 */,
/* 91 */,
/* 92 */,
/* 93 */,
/* 94 */,
/* 95 */,
/* 96 */,
/* 97 */,
/* 98 */,
/* 99 */,
/* 100 */,
/* 101 */,
/* 102 */,
/* 103 */,
/* 104 */,
/* 105 */,
/* 106 */,
/* 107 */,
/* 108 */,
/* 109 */,
/* 110 */,
/* 111 */,
/* 112 */,
/* 113 */,
/* 114 */,
/* 115 */,
/* 116 */,
/* 117 */,
/* 118 */,
/* 119 */,
/* 120 */,
/* 121 */,
/* 122 */,
/* 123 */,
/* 124 */,
/* 125 */,
/* 126 */,
/* 127 */,
/* 128 */,
/* 129 */,
/* 130 */,
/* 131 */,
/* 132 */,
/* 133 */,
/* 134 */,
/* 135 */,
/* 136 */,
/* 137 */,
/* 138 */,
/* 139 */,
/* 140 */,
/* 141 */,
/* 142 */,
/* 143 */,
/* 144 */,
/* 145 */,
/* 146 */,
/* 147 */,
/* 148 */,
/* 149 */,
/* 150 */,
/* 151 */,
/* 152 */,
/* 153 */,
/* 154 */,
/* 155 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(240)

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(185),
  /* template */
  __webpack_require__(283),
  /* scopeId */
  "data-v-59a7f37a",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 156 */,
/* 157 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_router__ = __webpack_require__(298);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_Home__ = __webpack_require__(260);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_Home___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__components_Home__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_Login__ = __webpack_require__(261);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_Login___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__components_Login__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_Register__ = __webpack_require__(271);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_Register___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__components_Register__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_Profile__ = __webpack_require__(262);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_Profile___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__components_Profile__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_ProfileItems__ = __webpack_require__(266);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_ProfileItems___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__components_ProfileItems__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__components_ProfileCollections__ = __webpack_require__(263);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__components_ProfileCollections___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7__components_ProfileCollections__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__components_ProfileFollowing__ = __webpack_require__(265);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__components_ProfileFollowing___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8__components_ProfileFollowing__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__components_ProfileFollowers__ = __webpack_require__(264);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__components_ProfileFollowers___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9__components_ProfileFollowers__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__components_ChatRoom__ = __webpack_require__(257);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__components_ChatRoom___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10__components_ChatRoom__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__components_ChatRoomListing__ = __webpack_require__(258);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__components_ChatRoomListing___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11__components_ChatRoomListing__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__components_Contribute__ = __webpack_require__(259);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__components_Contribute___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_12__components_Contribute__);














__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_1_vue_router__["a" /* default */]);

/* harmony default export */ __webpack_exports__["a"] = new __WEBPACK_IMPORTED_MODULE_1_vue_router__["a" /* default */]({
  base: '/social-ui/',
  routes: [{
    path: '/u/:profileId',
    component: __WEBPACK_IMPORTED_MODULE_5__components_Profile___default.a,
    props: true,
    children: [{
      path: 'i',
      name: 'profile/items',
      component: __WEBPACK_IMPORTED_MODULE_6__components_ProfileItems___default.a,
      props: true
    }, {
      path: 'c',
      name: 'profile/collections',
      component: __WEBPACK_IMPORTED_MODULE_7__components_ProfileCollections___default.a,
      props: true
    }, {
      path: 'e',
      name: 'profile/following',
      component: __WEBPACK_IMPORTED_MODULE_8__components_ProfileFollowing___default.a,
      props: true
    }, {
      path: 'r',
      name: 'profile/followers',
      component: __WEBPACK_IMPORTED_MODULE_9__components_ProfileFollowers___default.a,
      props: true
    }, {
      path: '',
      name: 'profile',
      redirect: {
        name: 'profile/items'
      }
    }]
  }, {
    path: '/a',
    name: 'Contribute',
    component: __WEBPACK_IMPORTED_MODULE_12__components_Contribute___default.a,
    props: true
  }, {
    path: '/c',
    name: 'chatroomListing',
    component: __WEBPACK_IMPORTED_MODULE_11__components_ChatRoomListing___default.a,
    props: true
  }, {
    path: '/c/:chatRoomId',
    name: 'chatroom',
    component: __WEBPACK_IMPORTED_MODULE_10__components_ChatRoom___default.a,
    props: true
  }, {
    path: '/login',
    name: 'login',
    component: __WEBPACK_IMPORTED_MODULE_3__components_Login___default.a,
    props: true
  }, {
    path: '/register',
    name: 'register',
    component: __WEBPACK_IMPORTED_MODULE_4__components_Register___default.a,
    props: true
  }, {
    path: '/',
    name: 'home',
    component: __WEBPACK_IMPORTED_MODULE_2__components_Home___default.a,
    props: true
  }]
});

/***/ }),
/* 158 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__modules_content__ = __webpack_require__(164);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__modules_users__ = __webpack_require__(166);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__modules_ui__ = __webpack_require__(165);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__modules_chats__ = __webpack_require__(163);







__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_1_vuex__["c" /* default */]);

var debug = "production" !== 'production';

/* harmony default export */ __webpack_exports__["a"] = new __WEBPACK_IMPORTED_MODULE_1_vuex__["c" /* default */].Store({
  getters: {
    routeQueryParams: function routeQueryParams(state, allGetters, rootState) {
      return rootState.route.query;
    },
    routeParams: function routeParams(state, allGetters, rootState) {
      return rootState.route.params;
    }
  },
  modules: {
    chats: __WEBPACK_IMPORTED_MODULE_5__modules_chats__["a" /* default */],
    content: __WEBPACK_IMPORTED_MODULE_2__modules_content__["a" /* default */],
    users: __WEBPACK_IMPORTED_MODULE_3__modules_users__["a" /* default */],
    ui: __WEBPACK_IMPORTED_MODULE_4__modules_ui__["a" /* default */]
  },
  strict: debug
});

/***/ }),
/* 159 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(251)

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(167),
  /* template */
  __webpack_require__(295),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 160 */,
/* 161 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_moment__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_moment__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_chance__ = __webpack_require__(33);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_chance___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_chance__);




function imageUrl(width, height) {
  var category = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : '';
  var stabilityHash = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : __WEBPACK_IMPORTED_MODULE_0_lodash___default.a.uniqueId('r');

  return ['https://placehold.it/' + width + 'x' + height + '?text=' + category + '+' + stabilityHash];
}

function generateProfile(_ref) {
  var profileId = _ref.profileId,
      chance = _ref.chance;

  var profile = {
    profileId: profileId,
    name: chance.name(),
    bio: chance.paragraph(),
    avatarUrl: chance.pickone(imageUrl(256, 256, 'people', profileId))
  };

  return profile;
}

function generateSocialNetwork() {
  var _ref2 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
      _ref2$numberOfPeople = _ref2.numberOfPeople,
      numberOfPeople = _ref2$numberOfPeople === undefined ? 20 : _ref2$numberOfPeople,
      _ref2$seed = _ref2.seed,
      seed = _ref2$seed === undefined ? 5330 : _ref2$seed;

  var chance = new __WEBPACK_IMPORTED_MODULE_2_chance___default.a(seed);

  var profileIdPool = chance.unique(chance.hash, numberOfPeople, { length: 6 });

  var listProfiles = __WEBPACK_IMPORTED_MODULE_0_lodash___default.a.map(profileIdPool, function (profileId) {
    var profile = generateProfile({
      profileId: profileId,
      chance: chance,
      maxFollowees: numberOfPeople - 1
    });
    return profile;
  });
  var profiles = __WEBPACK_IMPORTED_MODULE_0_lodash___default.a.keyBy(listProfiles, 'profileId');

  var listRelationships = __WEBPACK_IMPORTED_MODULE_0_lodash___default.a.map(profileIdPool, function (profileId) {
    var filteredProfileIdPool = __WEBPACK_IMPORTED_MODULE_0_lodash___default.a.reject(profileIdPool, function (id) {
      return profileId === id;
    });
    var profileIdGenerator = function profileIdGenerator() {
      return chance.pickone(filteredProfileIdPool);
    };
    return {
      profileId: profileId,
      type: 'isFollowing',
      followeeIds: chance.unique(profileIdGenerator, chance.natural({ max: numberOfPeople - 1 }))
    };
  });
  var relationships = __WEBPACK_IMPORTED_MODULE_0_lodash___default.a.keyBy(listRelationships, 'profileId');

  return {
    profileIds: profileIdPool,
    profiles: profiles,
    relationships: relationships
  };
}

function generateItem(_ref3) {
  var chance = _ref3.chance;

  var itemId = chance.hash({ length: 12 });
  var item = {
    itemId: itemId,
    type: 'image',
    content: chance.pickone(imageUrl(256, 256, '', itemId)),
    caption: chance.paragraph()
  };

  return item;
}

function generateCollection(_ref4) {
  var itemIds = _ref4.itemIds,
      chance = _ref4.chance;

  var collectionId = chance.hash({ length: 12 });
  var collection = {
    collectionId: collectionId,
    name: chance.word(),
    description: chance.paragraph({ sentences: 3 }),
    itemIds: itemIds
  };

  return collection;
}

function generateCuratedContent() {
  var _ref5 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
      profileIds = _ref5.profileIds,
      _ref5$seed = _ref5.seed,
      seed = _ref5$seed === undefined ? 5330 : _ref5$seed;

  var chance = new __WEBPACK_IMPORTED_MODULE_2_chance___default.a(seed);

  var listContent = __WEBPACK_IMPORTED_MODULE_0_lodash___default.a.map(profileIds, function (profileId) {
    var numberOfItems = chance.natural({ max: 30 });
    var numberOfCollections = chance.natural({ max: numberOfItems / 2 });

    var items = __WEBPACK_IMPORTED_MODULE_0_lodash___default.a.times(numberOfItems, function () {
      return generateItem({ chance: chance });
    });
    var collections = __WEBPACK_IMPORTED_MODULE_0_lodash___default.a.times(numberOfCollections, function () {
      var itemsForCollection = chance.pickset(items, chance.natural({ max: numberOfItems }));
      var itemIds = __WEBPACK_IMPORTED_MODULE_0_lodash___default.a.map(itemsForCollection, 'itemId');
      return generateCollection({
        itemIds: itemIds,
        chance: chance
      });
    });

    var content = {
      profileId: profileId,
      items: items,
      collections: collections
    };
    return content;
  });
  var contents = __WEBPACK_IMPORTED_MODULE_0_lodash___default.a.keyBy(listContent, 'profileId');

  return {
    contents: contents
  };
}

function generateChatMessage(_ref6) {
  var profileId = _ref6.profileId,
      chance = _ref6.chance;

  var messageId = chance.hash();
  return {
    messageId: messageId,
    ownerProfileId: profileId,
    timestamp: __WEBPACK_IMPORTED_MODULE_1_moment___default()().unix(),
    content: chance.paragraph()
  };
}

function generateChatRoom(_ref7) {
  var profileIds = _ref7.profileIds,
      chance = _ref7.chance;

  var chatRoomId = chance.hash({ length: 16 });
  var numberOfMessages = chance.natural({ max: __WEBPACK_IMPORTED_MODULE_0_lodash___default.a.size(profileIds) * 2 });
  return {
    chatRoomId: chatRoomId,
    title: chance.word(),
    messages: __WEBPACK_IMPORTED_MODULE_0_lodash___default.a.times(numberOfMessages, function () {
      var profileId = chance.pickone(profileIds);
      return generateChatMessage({ profileId: profileId, chance: chance });
    }),
    participants: profileIds
  };
}

function generateChats() {
  var _ref8 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
      profileIds = _ref8.profileIds,
      _ref8$seed = _ref8.seed,
      seed = _ref8$seed === undefined ? 5330 : _ref8$seed;

  var chance = new __WEBPACK_IMPORTED_MODULE_2_chance___default.a(seed);

  var numberOfChatRooms = chance.natural({ max: 10 });
  var listChatRooms = __WEBPACK_IMPORTED_MODULE_0_lodash___default.a.times(numberOfChatRooms, function () {
    var numberOfPeople = chance.natural({ max: __WEBPACK_IMPORTED_MODULE_0_lodash___default.a.size(profileIds) });
    var participants = chance.pickset(profileIds, numberOfPeople);
    return generateChatRoom({ profileIds: participants, chance: chance });
  });
  var chatRooms = __WEBPACK_IMPORTED_MODULE_0_lodash___default.a.keyBy(listChatRooms, 'chatRoomId');

  return {
    chatRooms: chatRooms
  };
}

/* harmony default export */ __webpack_exports__["a"] = {
  generateSocialNetwork: generateSocialNetwork,
  generateCuratedContent: generateCuratedContent,
  generateChats: generateChats
};

/***/ }),
/* 162 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_chance__ = __webpack_require__(33);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_chance___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_chance__);



var chance = new __WEBPACK_IMPORTED_MODULE_0_chance___default.a();

/* harmony default export */ __webpack_exports__["a"] = chance;

/***/ }),
/* 163 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__helpers_api__ = __webpack_require__(22);


var _localMutations;




var localState = {
  chatRoom: {
    chatRoomId: null,
    title: null,
    messages: [],
    participants: []
  },
  chatRoomListing: []
};

var localGetters = {
  chatRoom: function chatRoom(state) {
    return state.chatRoom;
  },
  chatRoomListing: function chatRoomListing(state) {
    return state.chatRoomListing;
  }
};

var USER_RETRIEVED_CHATROOM = 'USER:RETRIEVED:CHAT_ROOM';
var USER_RETRIEVED_CHATROOM_LISTING = 'USER:RETRIEVED:CHAT_ROOM_LISTING';
var USER_SEND_MESSAGE = 'USER:SEND:MESSAGE';

var localActions = {
  fetchChatRooms: function fetchChatRooms(_ref) {
    var commit = _ref.commit;

    var response = __WEBPACK_IMPORTED_MODULE_2__helpers_api__["a" /* default */].getChatRooms();
    response.then(function (_ref2) {
      var data = _ref2.data;

      var chatRooms = data;
      commit(USER_RETRIEVED_CHATROOM_LISTING, {
        chatRooms: chatRooms
      });
    });
  },
  fetchChatRoomById: function fetchChatRoomById(_ref3, _ref4) {
    var commit = _ref3.commit;
    var chatRoomId = _ref4.chatRoomId;

    var response = __WEBPACK_IMPORTED_MODULE_2__helpers_api__["a" /* default */].getChatRoomById(chatRoomId);
    response.then(function (_ref5) {
      var data = _ref5.data;

      var chatRoom = data;
      commit(USER_RETRIEVED_CHATROOM, {
        chatRoom: chatRoom
      });
    });
  },
  sendChatMessage: function sendChatMessage(_ref6, _ref7) {
    var commit = _ref6.commit;
    var chatRoomId = _ref7.chatRoomId,
        userId = _ref7.userId,
        message = _ref7.message;

    var response = __WEBPACK_IMPORTED_MODULE_2__helpers_api__["a" /* default */].sendMessageToChatRoom({
      chatRoomId: chatRoomId,
      userId: userId,
      message: message
    });
    response.then(function (_ref8) {
      var data = _ref8.data;

      var chatMessage = data;
      commit(USER_SEND_MESSAGE, {
        chatMessage: chatMessage
      });
    });
  }
};

var localMutations = (_localMutations = {}, __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_localMutations, USER_RETRIEVED_CHATROOM_LISTING, function (state, _ref9) {
  var chatRooms = _ref9.chatRooms;

  __WEBPACK_IMPORTED_MODULE_1_vue__["a" /* default */].set(state, 'chatRoomListing', chatRooms);
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_localMutations, USER_SEND_MESSAGE, function (state, _ref10) {
  var chatMessage = _ref10.chatMessage;

  state.chatRoom.messages.push(chatMessage);
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_localMutations, USER_RETRIEVED_CHATROOM, function (state, _ref11) {
  var chatRoom = _ref11.chatRoom;

  __WEBPACK_IMPORTED_MODULE_1_vue__["a" /* default */].set(state, 'chatRoom', chatRoom);
}), _localMutations);


/* harmony default export */ __webpack_exports__["a"] = {
  state: localState,
  actions: localActions,
  getters: localGetters,
  mutations: localMutations
};

/***/ }),
/* 164 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__helpers_api__ = __webpack_require__(22);


var _localMutations;




var localState = {
  content: [],
  collections: [],
  contentOwnerUserId: null
};

var localGetters = {
  items: function items(state) {
    return state.content;
  },
  collections: function collections(state) {
    return state.collections;
  },
  itemOwner: function itemOwner(state, getters) {
    return getters.userById(state.contentOwnerUserId);
  }
};

var USER_RETRIEVED_CONTENT = 'USER:RETRIEVED:CONTENT';
var USER_RETRIEVED_COLLECTIONS = 'USER:RETRIEVED:COLLECTIONS';

var localActions = {
  fetchContentByUserId: function fetchContentByUserId(_ref, _ref2) {
    var commit = _ref.commit;
    var profileId = _ref2.profileId;

    var response = __WEBPACK_IMPORTED_MODULE_1__helpers_api__["a" /* default */].getContentByUserId(profileId);
    response.then(function (_ref3) {
      var data = _ref3.data;

      var content = data;
      commit(USER_RETRIEVED_CONTENT, {
        userId: profileId,
        content: content
      });
    });
  },
  fetchCollectionsByUserId: function fetchCollectionsByUserId(_ref4, _ref5) {
    var commit = _ref4.commit;
    var profileId = _ref5.profileId;

    var response = __WEBPACK_IMPORTED_MODULE_1__helpers_api__["a" /* default */].getCollectionsByUserId(profileId);
    response.then(function (_ref6) {
      var data = _ref6.data;

      var collections = data;
      commit(USER_RETRIEVED_COLLECTIONS, {
        userId: profileId,
        collections: collections
      });
    });
  }
};

var localMutations = (_localMutations = {}, __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_localMutations, USER_RETRIEVED_CONTENT, function (state, _ref7) {
  var userId = _ref7.userId,
      content = _ref7.content;

  state.contentOwnerUserId = userId;
  state.content = content;
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_localMutations, USER_RETRIEVED_COLLECTIONS, function (state, _ref8) {
  var userId = _ref8.userId,
      collections = _ref8.collections;

  state.contentOwnerUserId = userId;
  state.collections = collections;
}), _localMutations);


/* harmony default export */ __webpack_exports__["a"] = {
  state: localState,
  actions: localActions,
  getters: localGetters,
  mutations: localMutations
};

/***/ }),
/* 165 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_lodash__);



var PROFILE_LAYOUT_TOP_DOWN = 'top-down';
var PROFILE_LAYOUT_NARROW_WIDE = 'narrow-wide';
var PROFILE_LAYOUT_HERO_SIDEBAR = 'hero-sidebar';
var VALID_PROFILE_LAYOUT_STYLES = [PROFILE_LAYOUT_TOP_DOWN, PROFILE_LAYOUT_NARROW_WIDE, PROFILE_LAYOUT_HERO_SIDEBAR];

var localState = {
  layoutStyles: {
    profile: PROFILE_LAYOUT_TOP_DOWN
  }
};

var localGetters = {
  profileLayoutStyle: function profileLayoutStyle(state) {
    return state.layoutStyles.profile;
  }
};

var UI_SET_PROFILE_LAYOUT_STYLE = 'UI:SET:PROFILE:LAYOUT_STYLE';

var localActions = {
  setProfileLayoutStyle: function setProfileLayoutStyle(_ref, _ref2) {
    var commit = _ref.commit;
    var layoutStyle = _ref2.layoutStyle;

    var found = __WEBPACK_IMPORTED_MODULE_1_lodash___default.a.find(VALID_PROFILE_LAYOUT_STYLES, function (item) {
      return item === layoutStyle;
    });

    commit(UI_SET_PROFILE_LAYOUT_STYLE, {
      layoutStyle: found
    });
  }
};

var localMutations = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()({}, UI_SET_PROFILE_LAYOUT_STYLE, function (state, _ref3) {
  var _ref3$layoutStyle = _ref3.layoutStyle,
      layoutStyle = _ref3$layoutStyle === undefined ? PROFILE_LAYOUT_TOP_DOWN : _ref3$layoutStyle;

  state.layoutStyles.profile = layoutStyle;
});


/* harmony default export */ __webpack_exports__["a"] = {
  state: localState,
  actions: localActions,
  getters: localGetters,
  mutations: localMutations
};

/***/ }),
/* 166 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_lodash__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__helpers_api__ = __webpack_require__(22);


var _localMutations;






var localState = {
  users: {},
  following: [],
  followedBy: [],
  activeUserId: 'me',
  meUserId: null
};

var localGetters = {
  isLoading: function isLoading(state) {
    return state.meUserId === null;
  },
  userById: function userById(state) {
    return function (userId) {
      return state.users[userId];
    };
  },
  realUserId: function realUserId(state) {
    return function (meOrUserId) {
      var userId = meOrUserId === 'me' ? state.meUserId : meOrUserId;
      return userId;
    };
  },
  activeUser: function activeUser(state, getters) {
    var userId = getters.realUserId(state.activeUserId);
    var user = getters.userById(userId);
    return user;
  },
  activeFollowing: function activeFollowing(state, getters) {
    var userFollowingList = __WEBPACK_IMPORTED_MODULE_2_lodash___default.a.map(state.following, function (followeeId) {
      return getters.userById(followeeId);
    });
    return userFollowingList;
  },
  activeFollowers: function activeFollowers(state, getters) {
    var userFollowersList = __WEBPACK_IMPORTED_MODULE_2_lodash___default.a.map(state.followedBy, function (followerId) {
      return getters.userById(followerId);
    });
    return userFollowersList;
  }
};

var USER_MAKE_ACTIVE = 'USER:MAKE_ACTIVE';
var USER_RETRIEVED = 'USER:RETRIEVED';
var USER_RETRIEVED_FOLLOWING = 'USER:RETRIEVED:FOLLOWING';
var USER_RETRIEVED_FOLLOWED_BY = 'USER:RETRIEVED:FOLLOWING_BY';
var USER_RETRIEVED_MY_RELATIONSHIPS = 'USER:RETRIEVED:MY_RELATIONSHIPS';
var USER_FOLLOW_USER = 'USER:FOLLOW:USER';
var USER_UNFOLLOW_USER = 'USER:UNFOLLOW:USER';

var localActions = {
  setActiveUserId: function setActiveUserId(_ref, _ref2) {
    var commit = _ref.commit;
    var profileId = _ref2.profileId;

    commit(USER_MAKE_ACTIVE, {
      userId: profileId
    });
  },
  fetchUserById: function fetchUserById(_ref3, _ref4) {
    var commit = _ref3.commit;
    var profileId = _ref4.profileId;

    var response = __WEBPACK_IMPORTED_MODULE_3__helpers_api__["a" /* default */].getUserById(profileId);
    response.then(function (_ref5) {
      var data = _ref5.data;

      var user = data;
      commit(USER_RETRIEVED, {
        user: user
      });
    });
  },
  fetchUserFollowingList: function fetchUserFollowingList(_ref6, _ref7) {
    var commit = _ref6.commit;
    var profileId = _ref7.profileId;

    var response = __WEBPACK_IMPORTED_MODULE_3__helpers_api__["a" /* default */].getFollowingList(profileId);
    response.then(function (_ref8) {
      var data = _ref8.data;

      var followingList = data;
      __WEBPACK_IMPORTED_MODULE_2_lodash___default.a.forEach(followingList, function (followee) {
        commit(USER_RETRIEVED, {
          user: followee
        });
      });

      var followingIdList = __WEBPACK_IMPORTED_MODULE_2_lodash___default.a.map(followingList, 'profileId');
      commit(USER_RETRIEVED_FOLLOWING, {
        followingIdList: followingIdList
      });
    });
  },
  fetchUserFollowedByList: function fetchUserFollowedByList(_ref9, _ref10) {
    var commit = _ref9.commit;
    var profileId = _ref10.profileId;

    var response = __WEBPACK_IMPORTED_MODULE_3__helpers_api__["a" /* default */].getFollowersList(profileId);
    response.then(function (_ref11) {
      var data = _ref11.data;

      var followersList = data;
      __WEBPACK_IMPORTED_MODULE_2_lodash___default.a.forEach(followersList, function (follower) {
        commit(USER_RETRIEVED, {
          user: follower
        });
      });

      var followerIdList = __WEBPACK_IMPORTED_MODULE_2_lodash___default.a.map(followersList, 'profileId');
      commit(USER_RETRIEVED_FOLLOWED_BY, {
        followerIdList: followerIdList
      });
    });
  },
  followUser: function followUser(_ref12, _ref13) {
    var commit = _ref12.commit;
    var profileId = _ref13.profileId;

    var response = __WEBPACK_IMPORTED_MODULE_3__helpers_api__["a" /* default */].followUser(profileId);

    response.then(function (_ref14) {
      var data = _ref14.data;

      var followedUser = data;

      commit(USER_FOLLOW_USER, {
        objectId: profileId
      });

      commit(USER_RETRIEVED, {
        user: followedUser
      });
    });
  },
  unfollowUser: function unfollowUser(_ref15, _ref16) {
    var commit = _ref15.commit;
    var profileId = _ref16.profileId;

    var response = __WEBPACK_IMPORTED_MODULE_3__helpers_api__["a" /* default */].unfollowUser(profileId);

    response.then(function (_ref17) {
      var data = _ref17.data;

      var unfollowedUser = data;

      commit(USER_UNFOLLOW_USER, {
        objectId: profileId
      });

      commit(USER_RETRIEVED, {
        user: unfollowedUser
      });
    });
  }
};

var localMutations = (_localMutations = {}, __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_localMutations, USER_MAKE_ACTIVE, function (state, _ref18) {
  var userId = _ref18.userId;

  state.activeUserId = userId;
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_localMutations, USER_RETRIEVED, function (state, _ref19) {
  var user = _ref19.user;

  var userId = user.profileId;
  __WEBPACK_IMPORTED_MODULE_1_vue__["a" /* default */].set(state.users, userId, user);
  if (user.isMe) {
    state.meUserId = user.profileId;
  }
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_localMutations, USER_RETRIEVED_FOLLOWING, function (state, _ref20) {
  var followingIdList = _ref20.followingIdList;

  state.following = followingIdList;
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_localMutations, USER_RETRIEVED_FOLLOWED_BY, function (state, _ref21) {
  var followerIdList = _ref21.followerIdList;

  state.followedBy = followerIdList;
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_localMutations, USER_RETRIEVED_MY_RELATIONSHIPS, function (state, _ref22) {
  var followingIdList = _ref22.followingIdList;

  __WEBPACK_IMPORTED_MODULE_2_lodash___default.a.forEach(followingIdList, function (followeeId) {
    __WEBPACK_IMPORTED_MODULE_1_vue__["a" /* default */].set(state.relationship, followeeId, true);
  });
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_localMutations, USER_FOLLOW_USER, function (state, _ref23) {
  var objectId = _ref23.objectId;

  var meUserId = state.meUserId;
  state.users[meUserId].stats.followee += 1;
  state.users[objectId].stats.follower += 1;
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_localMutations, USER_UNFOLLOW_USER, function (state, _ref24) {
  var objectId = _ref24.objectId;

  var meUserId = state.meUserId;
  state.users[meUserId].stats.followee -= 1;
  state.users[objectId].stats.follower -= 1;
}), _localMutations);


/* harmony default export */ __webpack_exports__["a"] = {
  state: localState,
  actions: localActions,
  getters: localGetters,
  mutations: localMutations
};

/***/ }),
/* 167 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__assets_main_scss__ = __webpack_require__(232);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__assets_main_scss___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__assets_main_scss__);



/* harmony default export */ __webpack_exports__["default"] = {
  name: 'app'
};

/***/ }),
/* 168 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_lodash__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_moment__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_moment__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__Header__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__Header___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__Header__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__Footer__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__Footer___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__Footer__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__layout_Bar__ = __webpack_require__(155);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__layout_Bar___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__layout_Bar__);










/* harmony default export */ __webpack_exports__["default"] = {
  props: ['chatRoomId'],
  components: {
    SuiHeader: __WEBPACK_IMPORTED_MODULE_4__Header___default.a,
    SuiFooter: __WEBPACK_IMPORTED_MODULE_5__Footer___default.a,
    Bar: __WEBPACK_IMPORTED_MODULE_6__layout_Bar___default.a
  },
  data: function data() {
    return {
      inputMessage: '',
      isModalVisible: false
    };
  },

  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vuex__["a" /* mapGetters */])(['chatRoom']), {
    modalClass: function modalClass() {
      return {
        'is-active': this.isModalVisible
      };
    },
    hasMessage: function hasMessage() {
      return this.inputMessage;
    },
    sendMessageClass: function sendMessageClass() {
      return {
        'is-white': !this.hasMessage,
        'is-primary': this.hasMessage
      };
    },
    countMessages: function countMessages() {
      if (!this.chatRoom) {
        return 0;
      }
      return __WEBPACK_IMPORTED_MODULE_2_lodash___default.a.size(this.chatRoom.messages);
    }
  }),
  methods: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vuex__["b" /* mapActions */])(['sendChatMessage', 'fetchChatRoomById', 'fetchUserById']), {
    openModal: function openModal() {
      this.isModalVisible = true;
    },
    closeModal: function closeModal() {
      this.isModalVisible = false;
    },
    sendMessage: function sendMessage(message) {
      if (__WEBPACK_IMPORTED_MODULE_2_lodash___default.a.isEmpty(message)) {
        return;
      }
      this.inputMessage = '';
      this.sendChatMessage({
        chatRoomId: this.chatRoom.chatRoomId,
        userId: 'me',
        message: message
      });
    },
    scrollToBottomOfChatMessages: function scrollToBottomOfChatMessages() {
      this.$nextTick(function () {
        document.getElementById('sui-messages-bottom').scrollIntoView();
      });
    },
    fetchChatRoom: function fetchChatRoom() {
      this.fetchChatRoomById({
        chatRoomId: this.chatRoomId
      });
      this.fetchUserById({
        profileId: 'me'
      });
      this.scrollToBottomOfChatMessages();
    },
    timeAgoFromTimestamp: function timeAgoFromTimestamp(timestamp) {
      return __WEBPACK_IMPORTED_MODULE_3_moment___default.a.unix(timestamp).fromNow();
    }
  }),
  created: function created() {
    this.fetchChatRoom();
  },

  watch: {
    chatRoomId: function chatRoomId(current, previous) {
      if (current !== previous) {
        this.fetchChatRoom();
      }
    },
    countMessages: function countMessages(current, previous) {
      if (current !== previous) {
        this.scrollToBottomOfChatMessages();
      }
    }
  }
};

/***/ }),
/* 169 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_moment__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_moment__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__Header__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__Header___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__Header__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__Footer__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__Footer___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__Footer__);








/* harmony default export */ __webpack_exports__["default"] = {
  name: 'chatroom-listing',
  props: [''],
  components: {
    SuiHeader: __WEBPACK_IMPORTED_MODULE_3__Header___default.a,
    SuiFooter: __WEBPACK_IMPORTED_MODULE_4__Footer___default.a
  },
  data: function data() {
    return {};
  },

  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vuex__["a" /* mapGetters */])(['chatRoomListing'])),
  methods: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vuex__["b" /* mapActions */])(['fetchChatRooms']), {
    timeFromTimestamp: function timeFromTimestamp(timestamp) {
      return __WEBPACK_IMPORTED_MODULE_2_moment___default.a.unix(timestamp).format('HH:mm');
    },
    dateFromTimestamp: function dateFromTimestamp(timestamp) {
      return __WEBPACK_IMPORTED_MODULE_2_moment___default.a.unix(timestamp).format('D/M/YY');
    }
  }),
  created: function created() {
    this.fetchChatRooms();
  }
};

/***/ }),
/* 170 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__helpers_chance__ = __webpack_require__(162);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__Header__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__Header___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__Header__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__Footer__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__Footer___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__Footer__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__layout_Bar__ = __webpack_require__(155);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__layout_Bar___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__layout_Bar__);









/* harmony default export */ __webpack_exports__["default"] = {
  name: 'contribute',
  props: [],
  components: {
    SuiHeader: __WEBPACK_IMPORTED_MODULE_3__Header___default.a,
    SuiFooter: __WEBPACK_IMPORTED_MODULE_4__Footer___default.a,
    Bar: __WEBPACK_IMPORTED_MODULE_5__layout_Bar___default.a
  },
  data: function data() {
    return {
      caption: '',
      attachmentList: []
    };
  },
  created: function created() {
    this.addAttachmentImage();
  },

  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vuex__["a" /* mapGetters */])({}), {
    numberOfAttachments: function numberOfAttachments() {
      return this.attachmentList.length;
    },
    attachmentListType: function attachmentListType() {
      if (this.numberOfAttachments === 0) {
        return null;
      }
      var headAttachment = this.attachmentList[0];
      return headAttachment.type;
    },
    canAddImages: function canAddImages() {
      var type = this.attachmentListType;
      if (!type || type === 'image' && this.numberOfAttachments < 5) {
        return true;
      }
      return false;
    },
    canAddVideos: function canAddVideos() {
      var type = this.attachmentListType;
      if (!type || type === 'video' && this.numberOfAttachments < 1) {
        return true;
      }
      return false;
    },
    canAddLinks: function canAddLinks() {
      var type = this.attachmentListType;
      if (!type || type === 'link' && this.numberOfAttachments < 1) {
        return true;
      }
      return false;
    }
  }),
  methods: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vuex__["b" /* mapActions */])([]), {
    addHashTag: function addHashTag() {
      this.caption += ' #';
      this.$refs.caption.focus();
    },
    addMention: function addMention() {
      this.caption += ' @';
      this.$refs.caption.focus();
    },
    addAttachmentImage: function addAttachmentImage() {
      this.attachmentList.push({
        type: 'image',
        url: 'http://placehold.it/128x128?text=image'
      });
    },
    addAttachmentVideo: function addAttachmentVideo() {
      this.attachmentList.push({
        type: 'video',
        url: 'http://placehold.it/128x128?text=video'
      });
    },
    addAttachmentLink: function addAttachmentLink() {
      this.attachmentList.push({
        type: 'link',
        url: __WEBPACK_IMPORTED_MODULE_2__helpers_chance__["a" /* default */].url(),
        caption: __WEBPACK_IMPORTED_MODULE_2__helpers_chance__["a" /* default */].paragraph({ sentences: 2 }),
        imageUrl: 'http://placehold.it/64x64?text=url'
      });
    },
    removeAttachment: function removeAttachment($index) {
      this.attachmentList.splice($index, 1);
    },
    contributeContent: function contributeContent() {
      this.$router.push({
        name: 'profile',
        params: {
          profileId: 'me'
        }
      });
    }
  })
};

/***/ }),
/* 171 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });


/* harmony default export */ __webpack_exports__["default"] = {
  name: 'footer',
  components: {},
  data: function data() {
    return {};
  }
};

/***/ }),
/* 172 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__ProfileSwitcher__ = __webpack_require__(270);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__ProfileSwitcher___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__ProfileSwitcher__);




/* harmony default export */ __webpack_exports__["default"] = {
  name: 'profile',
  components: {
    ProfileSwitcher: __WEBPACK_IMPORTED_MODULE_0__ProfileSwitcher___default.a
  },
  data: function data() {
    return {
      isNavMenuActive: false
    };
  },

  computed: {
    navMenuClass: function navMenuClass() {
      return {
        'is-active': this.isNavMenuActive
      };
    }
  },
  methods: {
    toggleMenu: function toggleMenu() {
      this.isNavMenuActive = !this.isNavMenuActive;
    }
  }
};

/***/ }),
/* 173 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Footer__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Footer___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__Footer__);




/* harmony default export */ __webpack_exports__["default"] = {
  components: {
    SuiFooter: __WEBPACK_IMPORTED_MODULE_0__Footer___default.a
  }
};

/***/ }),
/* 174 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Footer__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Footer___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__Footer__);




/* harmony default export */ __webpack_exports__["default"] = {
  components: {
    SuiFooter: __WEBPACK_IMPORTED_MODULE_0__Footer___default.a
  }
};

/***/ }),
/* 175 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_ProfileLayout_TopDown__ = __webpack_require__(269);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_ProfileLayout_TopDown___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__components_ProfileLayout_TopDown__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_ProfileLayout_NarrowWide__ = __webpack_require__(268);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_ProfileLayout_NarrowWide___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__components_ProfileLayout_NarrowWide__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_ProfileLayout_HeroSidebar__ = __webpack_require__(267);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_ProfileLayout_HeroSidebar___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__components_ProfileLayout_HeroSidebar__);








/* harmony default export */ __webpack_exports__["default"] = {
  props: ['profileId'],
  components: {
    'top-down': __WEBPACK_IMPORTED_MODULE_2__components_ProfileLayout_TopDown___default.a,
    'narrow-wide': __WEBPACK_IMPORTED_MODULE_3__components_ProfileLayout_NarrowWide___default.a,
    'hero-sidebar': __WEBPACK_IMPORTED_MODULE_4__components_ProfileLayout_HeroSidebar___default.a
  },
  data: function data() {
    return {};
  },

  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vuex__["a" /* mapGetters */])(['routeParams', 'routeQueryParams', 'profileLayoutStyle', 'isLoading']), {
    activeComponent: function activeComponent() {
      return this.profileLayoutStyle;
    }
  }),
  methods: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vuex__["b" /* mapActions */])(['setProfileLayoutStyle', 'fetchUserById', 'setActiveUserId']), {
    maybeUpdateProfileLayoutStyle: function maybeUpdateProfileLayoutStyle() {
      if (this.routeQueryParams && this.routeQueryParams.layout) {
        var layoutStyle = this.routeQueryParams.layout;
        this.setProfileLayoutStyle({ layoutStyle: layoutStyle });
      }
    },
    fetchProfile: function fetchProfile(profileId) {
      this.fetchUserById({
        profileId: profileId
      });
      this.setActiveUserId({
        profileId: profileId
      });
    }
  }),
  created: function created() {
    this.maybeUpdateProfileLayoutStyle();
    this.fetchProfile('me');
    this.fetchProfile(this.routeParams.profileId);
  },

  watch: {
    routeQueryParams: function routeQueryParams() {
      this.maybeUpdateProfileLayoutStyle();
    },
    routeParams: function routeParams(current, previous) {
      if (current.profileId !== previous.profileId) {
        this.fetchProfile(current.profileId);
      }
    }
  }
};

/***/ }),
/* 176 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__(3);





/* harmony default export */ __webpack_exports__["default"] = {
  name: 'profileCollections',
  props: ['person'],
  data: function data() {
    return {};
  },

  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vuex__["a" /* mapGetters */])({
    collectionList: 'collections'
  })),
  methods: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vuex__["b" /* mapActions */])(['fetchCollectionsByUserId']), {
    fetchData: function fetchData() {
      this.fetchCollectionsByUserId({
        profileId: this.person.profileId
      });
    }
  }),
  created: function created() {
    this.fetchData();
  },

  watch: {
    person: function person(current, previous) {
      if (current !== previous) {
        this.fetchData();
      }
    }
  }
};

/***/ }),
/* 177 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__(3);





/* harmony default export */ __webpack_exports__["default"] = {
  name: 'profileFollowers',
  props: ['person'],
  data: function data() {
    return {};
  },
  created: function created() {
    this.fetchUserList();
  },

  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vuex__["a" /* mapGetters */])({
    personList: 'activeFollowers'
  })),
  methods: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vuex__["b" /* mapActions */])(['fetchUserFollowedByList', 'followUser', 'unfollowUser']), {
    followPerson: function followPerson(person) {
      this.followUser({
        profileId: person.profileId
      });
    },
    unfollowPerson: function unfollowPerson(person) {
      this.unfollowUser({
        profileId: person.profileId
      });
    },
    fetchUserList: function fetchUserList() {
      this.fetchUserFollowedByList({
        profileId: this.person.profileId
      });
    }
  }),
  watch: {
    peopleListType: function peopleListType(current, previous) {
      if (current !== previous) {
        this.fetchUserList();
      }
    }
  }
};

/***/ }),
/* 178 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__(3);





/* harmony default export */ __webpack_exports__["default"] = {
  name: 'profileFollowing',
  props: ['person'],
  data: function data() {
    return {};
  },
  created: function created() {
    this.fetchUserList();
  },

  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vuex__["a" /* mapGetters */])({
    personList: 'activeFollowing'
  })),
  methods: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vuex__["b" /* mapActions */])(['fetchUserFollowingList', 'followUser', 'unfollowUser']), {
    followPerson: function followPerson(person) {
      this.followUser({
        profileId: person.profileId
      });
    },
    unfollowPerson: function unfollowPerson(person) {
      this.unfollowUser({
        profileId: person.profileId
      });
    },
    fetchUserList: function fetchUserList() {
      this.fetchUserFollowingList({
        profileId: this.person.profileId
      });
    }
  }),
  watch: {
    peopleListType: function peopleListType(current, previous) {
      if (current !== previous) {
        this.fetchUserList();
      }
    }
  }
};

/***/ }),
/* 179 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__(3);





/* harmony default export */ __webpack_exports__["default"] = {
  name: 'profileItems',
  props: ['person'],
  data: function data() {
    return {
      isModalVisible: false,
      selectedItem: null
    };
  },

  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vuex__["a" /* mapGetters */])(['items', 'itemOwner']), {
    modalClass: function modalClass() {
      return {
        'is-active': this.isModalVisible
      };
    },
    itemList: function itemList() {
      return this.items;
    },
    modalData: function modalData() {
      var selectedItem = this.selectedItem || {};
      var user = this.itemOwner || {};
      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, selectedItem, {
        owner: user
      });
    }
  }),
  methods: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vuex__["b" /* mapActions */])(['fetchContentByUserId']), {
    openModal: function openModal(item) {
      this.selectedItem = item;
      this.isModalVisible = true;
    },
    closeModal: function closeModal() {
      this.isModalVisible = false;
      this.selectedItem = null;
    },
    fetchItems: function fetchItems() {
      this.fetchContentByUserId({
        profileId: this.person.profileId
      });
    }
  }),
  created: function created() {
    this.fetchItems();
  },

  watch: {
    person: function person(current, previous) {
      if (current !== previous) {
        this.fetchItems();
      }
    }
  }
};

/***/ }),
/* 180 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Header__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Header___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__Header__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__Footer__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__Footer___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__Footer__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__profile_Header_hero__ = __webpack_require__(272);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__profile_Header_hero___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__profile_Header_hero__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__profile_Header_mobile__ = __webpack_require__(31);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__profile_Header_mobile___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__profile_Header_mobile__);









/* harmony default export */ __webpack_exports__["default"] = {
  name: 'profile--top-down',
  props: ['profileId'],
  components: {
    SuiHeader: __WEBPACK_IMPORTED_MODULE_2__Header___default.a,
    SuiFooter: __WEBPACK_IMPORTED_MODULE_3__Footer___default.a,
    ProfileHeaderMobile: __WEBPACK_IMPORTED_MODULE_5__profile_Header_mobile___default.a,
    ProfileHeaderHero: __WEBPACK_IMPORTED_MODULE_4__profile_Header_hero___default.a
  },
  data: function data() {
    return {};
  },

  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vuex__["a" /* mapGetters */])({
    person: 'activeUser'
  }))
};

/***/ }),
/* 181 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Header__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Header___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__Header__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__Footer__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__Footer___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__Footer__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__profile_Header_narrow__ = __webpack_require__(273);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__profile_Header_narrow___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__profile_Header_narrow__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__profile_Header_mobile__ = __webpack_require__(31);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__profile_Header_mobile___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__profile_Header_mobile__);









/* harmony default export */ __webpack_exports__["default"] = {
  name: 'profile--narrow-wide',
  props: ['profileId'],
  components: {
    SuiHeader: __WEBPACK_IMPORTED_MODULE_2__Header___default.a,
    SuiFooter: __WEBPACK_IMPORTED_MODULE_3__Footer___default.a,
    ProfileHeaderNarrow: __WEBPACK_IMPORTED_MODULE_4__profile_Header_narrow___default.a,
    ProfileHeaderMobile: __WEBPACK_IMPORTED_MODULE_5__profile_Header_mobile___default.a
  },
  data: function data() {
    return {};
  },

  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vuex__["a" /* mapGetters */])({
    person: 'activeUser'
  }))
};

/***/ }),
/* 182 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Header__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Header___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__Header__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__Footer__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__Footer___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__Footer__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__profile_Header_wide__ = __webpack_require__(274);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__profile_Header_wide___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__profile_Header_wide__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__profile_Header_mobile__ = __webpack_require__(31);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__profile_Header_mobile___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__profile_Header_mobile__);









/* harmony default export */ __webpack_exports__["default"] = {
  name: 'profile--top-down',
  props: ['profileId'],
  components: {
    SuiHeader: __WEBPACK_IMPORTED_MODULE_2__Header___default.a,
    SuiFooter: __WEBPACK_IMPORTED_MODULE_3__Footer___default.a,
    ProfileHeaderMobile: __WEBPACK_IMPORTED_MODULE_5__profile_Header_mobile___default.a,
    ProfileHeaderWide: __WEBPACK_IMPORTED_MODULE_4__profile_Header_wide___default.a
  },
  data: function data() {
    return {};
  },

  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vuex__["a" /* mapGetters */])({
    person: 'activeUser'
  }))
};

/***/ }),
/* 183 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__(3);





/* harmony default export */ __webpack_exports__["default"] = {
  data: function data() {
    return {
      layoutStyles: ['top-down', 'narrow-wide', 'hero-sidebar']
    };
  },

  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vuex__["a" /* mapGetters */])(['profileLayoutStyle']), {
    selectedLayout: {
      get: function get() {
        return this.profileLayoutStyle;
      },
      set: function set(layoutStyle) {
        this.setProfileLayoutStyle({ layoutStyle: layoutStyle });
      }
    }
  }),
  methods: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vuex__["b" /* mapActions */])(['setProfileLayoutStyle']))
};

/***/ }),
/* 184 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Footer__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Footer___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__Footer__);




/* harmony default export */ __webpack_exports__["default"] = {
  components: {
    SuiFooter: __WEBPACK_IMPORTED_MODULE_0__Footer___default.a
  }
};

/***/ }),
/* 185 */
/***/ (function(module, exports) {



/***/ }),
/* 186 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__(3);





/* harmony default export */ __webpack_exports__["default"] = {
  props: {
    person: Object
  },
  data: function data() {
    return {};
  },

  methods: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vuex__["b" /* mapActions */])(['followUser', 'unfollowUser']), {
    followPerson: function followPerson(person) {
      this.followUser({
        profileId: person.profileId
      });
    },
    unfollowPerson: function unfollowPerson(person) {
      this.unfollowUser({
        profileId: person.profileId
      });
    }
  })
};

/***/ }),
/* 187 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__(3);





/* harmony default export */ __webpack_exports__["default"] = {
  props: {
    person: Object
  },
  data: function data() {
    return {};
  },

  methods: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vuex__["b" /* mapActions */])(['followUser', 'unfollowUser']), {
    followPerson: function followPerson(person) {
      this.followUser({
        profileId: person.profileId
      });
    },
    unfollowPerson: function unfollowPerson(person) {
      this.unfollowUser({
        profileId: person.profileId
      });
    }
  })
};

/***/ }),
/* 188 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__(3);





/* harmony default export */ __webpack_exports__["default"] = {
  props: {
    person: Object
  },
  data: function data() {
    return {};
  },

  methods: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vuex__["b" /* mapActions */])(['followUser', 'unfollowUser']), {
    followPerson: function followPerson(person) {
      this.followUser({
        profileId: person.profileId
      });
    },
    unfollowPerson: function unfollowPerson(person) {
      this.unfollowUser({
        profileId: person.profileId
      });
    }
  })
};

/***/ }),
/* 189 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__(3);





/* harmony default export */ __webpack_exports__["default"] = {
  props: {
    person: Object
  },
  data: function data() {
    return {};
  },

  methods: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vuex__["b" /* mapActions */])(['followUser', 'unfollowUser']), {
    followPerson: function followPerson(person) {
      this.followUser({
        profileId: person.profileId
      });
    },
    unfollowPerson: function unfollowPerson(person) {
      this.unfollowUser({
        profileId: person.profileId
      });
    }
  })
};

/***/ }),
/* 190 */,
/* 191 */,
/* 192 */,
/* 193 */,
/* 194 */,
/* 195 */,
/* 196 */,
/* 197 */,
/* 198 */,
/* 199 */,
/* 200 */,
/* 201 */,
/* 202 */,
/* 203 */,
/* 204 */,
/* 205 */,
/* 206 */,
/* 207 */,
/* 208 */,
/* 209 */,
/* 210 */,
/* 211 */,
/* 212 */,
/* 213 */,
/* 214 */,
/* 215 */,
/* 216 */,
/* 217 */,
/* 218 */,
/* 219 */,
/* 220 */,
/* 221 */,
/* 222 */,
/* 223 */,
/* 224 */,
/* 225 */,
/* 226 */,
/* 227 */,
/* 228 */,
/* 229 */,
/* 230 */,
/* 231 */,
/* 232 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 233 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 234 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 235 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 236 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 237 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 238 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 239 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 240 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 241 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 242 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 243 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 244 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 245 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 246 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 247 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 248 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 249 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 250 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 251 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 252 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 253 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 254 */,
/* 255 */,
/* 256 */
/***/ (function(module, exports, __webpack_require__) {

var map = {
	"./af": 47,
	"./af.js": 47,
	"./ar": 53,
	"./ar-dz": 48,
	"./ar-dz.js": 48,
	"./ar-ly": 49,
	"./ar-ly.js": 49,
	"./ar-ma": 50,
	"./ar-ma.js": 50,
	"./ar-sa": 51,
	"./ar-sa.js": 51,
	"./ar-tn": 52,
	"./ar-tn.js": 52,
	"./ar.js": 53,
	"./az": 54,
	"./az.js": 54,
	"./be": 55,
	"./be.js": 55,
	"./bg": 56,
	"./bg.js": 56,
	"./bn": 57,
	"./bn.js": 57,
	"./bo": 58,
	"./bo.js": 58,
	"./br": 59,
	"./br.js": 59,
	"./bs": 60,
	"./bs.js": 60,
	"./ca": 61,
	"./ca.js": 61,
	"./cs": 62,
	"./cs.js": 62,
	"./cv": 63,
	"./cv.js": 63,
	"./cy": 64,
	"./cy.js": 64,
	"./da": 65,
	"./da.js": 65,
	"./de": 67,
	"./de-at": 66,
	"./de-at.js": 66,
	"./de.js": 67,
	"./dv": 68,
	"./dv.js": 68,
	"./el": 69,
	"./el.js": 69,
	"./en-au": 70,
	"./en-au.js": 70,
	"./en-ca": 71,
	"./en-ca.js": 71,
	"./en-gb": 72,
	"./en-gb.js": 72,
	"./en-ie": 73,
	"./en-ie.js": 73,
	"./en-nz": 74,
	"./en-nz.js": 74,
	"./eo": 75,
	"./eo.js": 75,
	"./es": 77,
	"./es-do": 76,
	"./es-do.js": 76,
	"./es.js": 77,
	"./et": 78,
	"./et.js": 78,
	"./eu": 79,
	"./eu.js": 79,
	"./fa": 80,
	"./fa.js": 80,
	"./fi": 81,
	"./fi.js": 81,
	"./fo": 82,
	"./fo.js": 82,
	"./fr": 85,
	"./fr-ca": 83,
	"./fr-ca.js": 83,
	"./fr-ch": 84,
	"./fr-ch.js": 84,
	"./fr.js": 85,
	"./fy": 86,
	"./fy.js": 86,
	"./gd": 87,
	"./gd.js": 87,
	"./gl": 88,
	"./gl.js": 88,
	"./he": 89,
	"./he.js": 89,
	"./hi": 90,
	"./hi.js": 90,
	"./hr": 91,
	"./hr.js": 91,
	"./hu": 92,
	"./hu.js": 92,
	"./hy-am": 93,
	"./hy-am.js": 93,
	"./id": 94,
	"./id.js": 94,
	"./is": 95,
	"./is.js": 95,
	"./it": 96,
	"./it.js": 96,
	"./ja": 97,
	"./ja.js": 97,
	"./jv": 98,
	"./jv.js": 98,
	"./ka": 99,
	"./ka.js": 99,
	"./kk": 100,
	"./kk.js": 100,
	"./km": 101,
	"./km.js": 101,
	"./ko": 102,
	"./ko.js": 102,
	"./ky": 103,
	"./ky.js": 103,
	"./lb": 104,
	"./lb.js": 104,
	"./lo": 105,
	"./lo.js": 105,
	"./lt": 106,
	"./lt.js": 106,
	"./lv": 107,
	"./lv.js": 107,
	"./me": 108,
	"./me.js": 108,
	"./mi": 109,
	"./mi.js": 109,
	"./mk": 110,
	"./mk.js": 110,
	"./ml": 111,
	"./ml.js": 111,
	"./mr": 112,
	"./mr.js": 112,
	"./ms": 114,
	"./ms-my": 113,
	"./ms-my.js": 113,
	"./ms.js": 114,
	"./my": 115,
	"./my.js": 115,
	"./nb": 116,
	"./nb.js": 116,
	"./ne": 117,
	"./ne.js": 117,
	"./nl": 119,
	"./nl-be": 118,
	"./nl-be.js": 118,
	"./nl.js": 119,
	"./nn": 120,
	"./nn.js": 120,
	"./pa-in": 121,
	"./pa-in.js": 121,
	"./pl": 122,
	"./pl.js": 122,
	"./pt": 124,
	"./pt-br": 123,
	"./pt-br.js": 123,
	"./pt.js": 124,
	"./ro": 125,
	"./ro.js": 125,
	"./ru": 126,
	"./ru.js": 126,
	"./se": 127,
	"./se.js": 127,
	"./si": 128,
	"./si.js": 128,
	"./sk": 129,
	"./sk.js": 129,
	"./sl": 130,
	"./sl.js": 130,
	"./sq": 131,
	"./sq.js": 131,
	"./sr": 133,
	"./sr-cyrl": 132,
	"./sr-cyrl.js": 132,
	"./sr.js": 133,
	"./ss": 134,
	"./ss.js": 134,
	"./sv": 135,
	"./sv.js": 135,
	"./sw": 136,
	"./sw.js": 136,
	"./ta": 137,
	"./ta.js": 137,
	"./te": 138,
	"./te.js": 138,
	"./tet": 139,
	"./tet.js": 139,
	"./th": 140,
	"./th.js": 140,
	"./tl-ph": 141,
	"./tl-ph.js": 141,
	"./tlh": 142,
	"./tlh.js": 142,
	"./tr": 143,
	"./tr.js": 143,
	"./tzl": 144,
	"./tzl.js": 144,
	"./tzm": 146,
	"./tzm-latn": 145,
	"./tzm-latn.js": 145,
	"./tzm.js": 146,
	"./uk": 147,
	"./uk.js": 147,
	"./uz": 148,
	"./uz.js": 148,
	"./vi": 149,
	"./vi.js": 149,
	"./x-pseudo": 150,
	"./x-pseudo.js": 150,
	"./yo": 151,
	"./yo.js": 151,
	"./zh-cn": 152,
	"./zh-cn.js": 152,
	"./zh-hk": 153,
	"./zh-hk.js": 153,
	"./zh-tw": 154,
	"./zh-tw.js": 154
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 256;


/***/ }),
/* 257 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(247)

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(168),
  /* template */
  __webpack_require__(291),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 258 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(243)

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(169),
  /* template */
  __webpack_require__(287),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 259 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(242)

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(170),
  /* template */
  __webpack_require__(286),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 260 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(250)

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(173),
  /* template */
  __webpack_require__(294),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 261 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(235)

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(174),
  /* template */
  __webpack_require__(277),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 262 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(175),
  /* template */
  __webpack_require__(282),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 263 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(237)

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(176),
  /* template */
  __webpack_require__(279),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 264 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(244)

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(177),
  /* template */
  __webpack_require__(288),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 265 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(238)

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(178),
  /* template */
  __webpack_require__(280),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 266 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(241)

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(179),
  /* template */
  __webpack_require__(284),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 267 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(233)

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(180),
  /* template */
  __webpack_require__(275),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 268 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(245)

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(181),
  /* template */
  __webpack_require__(289),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 269 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(248)

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(182),
  /* template */
  __webpack_require__(292),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 270 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(183),
  /* template */
  __webpack_require__(285),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 271 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(236)

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(184),
  /* template */
  __webpack_require__(278),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 272 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(234)

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(186),
  /* template */
  __webpack_require__(276),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 273 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(246)

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(188),
  /* template */
  __webpack_require__(290),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 274 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(239)

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(189),
  /* template */
  __webpack_require__(281),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 275 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "profile"
  }, [_c('sui-header'), _vm._v(" "), _c('div', {
    staticClass: "hero is-dark"
  }, [_c('div', {
    staticClass: "hero-body"
  }, [_c('div', {
    staticClass: "container"
  }, [_c('div', {
    staticClass: "is-hidden-mobile"
  }, [_c('profile-header-hero', {
    attrs: {
      "person": _vm.person
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "is-hidden-tablet"
  }, [_c('profile-header-mobile', {
    attrs: {
      "person": _vm.person
    }
  })], 1)])])]), _vm._v(" "), _c('div', {
    staticClass: "section"
  }, [_c('div', {
    staticClass: "container"
  }, [_c('div', {
    staticClass: "columns"
  }, [_c('div', {
    staticClass: "column is-one-quarter"
  }, [_c('aside', {
    staticClass: "menu"
  }, [_c('p', {
    staticClass: "menu-label"
  }, [_vm._v("\n              Explore " + _vm._s(_vm.person.name) + "\n            ")]), _vm._v(" "), _c('ul', {
    staticClass: "menu-list"
  }, [_c('li', [_c('router-link', {
    attrs: {
      "to": {
        name: 'profile/items',
        params: {
          profileId: _vm.profileId
        }
      },
      "active-class": "is-active"
    }
  }, [_c('span', {
    staticClass: "panel-icon"
  }, [_c('i', {
    staticClass: "fa fa-th"
  })]), _vm._v("\n                  Items -\n                  " + _vm._s(_vm.person.stats.item) + "\n                ")])], 1), _vm._v(" "), _c('li', [_c('router-link', {
    attrs: {
      "to": {
        name: 'profile/collections',
        params: {
          profileId: _vm.profileId
        }
      },
      "active-class": "is-active"
    }
  }, [_c('span', {
    staticClass: "panel-icon"
  }, [_c('i', {
    staticClass: "fa fa-list"
  })]), _vm._v("\n                  Collections -\n                  " + _vm._s(_vm.person.stats.collection) + "\n                ")])], 1)]), _vm._v(" "), _c('p', {
    staticClass: "menu-label"
  }, [_vm._v("\n              People\n            ")]), _vm._v(" "), _c('ul', {
    staticClass: "menu-list"
  }, [_c('li', [_c('router-link', {
    attrs: {
      "to": {
        name: 'profile/following',
        params: {
          profileId: _vm.profileId
        }
      },
      "active-class": "is-active"
    }
  }, [_c('span', {
    staticClass: "panel-icon"
  }, [_c('i', {
    staticClass: "fa fa-eye"
  })]), _vm._v("\n                  Following -\n                  " + _vm._s(_vm.person.stats.followee) + "\n                ")])], 1), _vm._v(" "), _c('li', [_c('router-link', {
    attrs: {
      "to": {
        name: 'profile/followers',
        params: {
          profileId: _vm.profileId
        }
      },
      "active-class": "is-active"
    }
  }, [_c('span', {
    staticClass: "panel-icon"
  }, [_c('i', {
    staticClass: "fa fa-users"
  })]), _vm._v("\n                  Followers -\n                  " + _vm._s(_vm.person.stats.follower) + "\n                ")])], 1)])])]), _vm._v(" "), _c('div', {
    staticClass: "column"
  }, [_c('router-view', {
    attrs: {
      "person": _vm.person
    }
  })], 1)])])]), _vm._v(" "), _c('sui-footer')], 1)
},staticRenderFns: []}

/***/ }),
/* 276 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    staticClass: "columns is-mobile"
  }, [_c('div', {
    staticClass: "column is-4 is-offset-4"
  }, [_c('div', {
    staticClass: "image is-1by1 sui-avatar"
  }, [_c('img', {
    attrs: {
      "src": _vm.person.avatarUrl
    }
  })])])]), _vm._v(" "), _c('div', {
    staticClass: "columns has-text-centered"
  }, [_c('div', {
    staticClass: "column content"
  }, [_c('p', [_c('span', {
    staticClass: "title is-bold"
  }, [_vm._v("\n          " + _vm._s(_vm.person.name) + "\n        ")]), _vm._v(" "), (!_vm.person.isMe) ? [_vm._v("\n           \n          "), (_vm.person.isFollowed) ? _c('button', {
    staticClass: "button is-dark is-inverted is-outlined",
    on: {
      "click": function($event) {
        _vm.unfollowPerson(_vm.person)
      }
    }
  }, [_vm._v("following")]) : _c('button', {
    staticClass: "button is-primary",
    on: {
      "click": function($event) {
        _vm.followPerson(_vm.person)
      }
    }
  }, [_vm._v("follow")])] : _vm._e()], 2), _vm._v(" "), _c('p', [_c('span', {
    staticClass: "subtitle"
  }, [_c('small', [_vm._v(_vm._s(_vm.person.bio))])])])])])])
},staticRenderFns: []}

/***/ }),
/* 277 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "account-login"
  }, [_c('section', {
    staticClass: "hero is-light is-fullheight"
  }, [_c('div', {
    staticClass: "hero-head"
  }, [_c('header', {
    staticClass: "nav"
  }, [_c('div', {
    staticClass: "container"
  }, [_c('div', {
    staticClass: "nav-left"
  }, [_c('router-link', {
    staticClass: "nav-item",
    attrs: {
      "to": {
        name: 'home'
      }
    }
  }, [_c('img', {
    attrs: {
      "src": "https://placehold.it/64x64",
      "alt": "social-ui"
    }
  }), _vm._v(" social-ui\n            ")])], 1)])])]), _vm._v(" "), _c('div', {
    staticClass: "hero-body"
  }, [_c('div', {
    staticClass: "container is-fluid"
  }, [_c('div', {
    staticClass: "columns"
  }, [_c('div', {
    staticClass: "column is-4 is-offset-4"
  }, [_c('form', {
    staticClass: "box"
  }, [_c('p'), _vm._m(0), _vm._v(" "), _c('p'), _vm._v(" "), _c('hr'), _vm._v(" "), _vm._m(1), _vm._v(" "), _vm._m(2), _vm._v(" "), _c('hr'), _vm._v(" "), _c('div', {
    staticClass: "field"
  }, [_c('p', {
    staticClass: "control"
  }, [_c('router-link', {
    staticClass: "button is-medium is-primary is-fullwidth",
    attrs: {
      "tag": "button",
      "to": {
        name: 'profile',
        params: {
          profileId: 'me'
        }
      }
    }
  }, [_vm._v("\n                    Login\n                  ")])], 1)])]), _vm._v(" "), _c('div', {
    staticClass: "box has-text-centered"
  }, [_c('router-link', {
    staticClass: "button is-dark is-inverted is-fullwidth",
    attrs: {
      "to": {
        name: 'register'
      }
    }
  }, [_vm._v("\n                Register an account >\n              ")])], 1)])])])])]), _vm._v(" "), _c('sui-footer')], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "image is-16by9"
  }, [_c('img', {
    attrs: {
      "src": "https://placehold.it/160x90"
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "field"
  }, [_c('p', {
    staticClass: "control has-icon"
  }, [_c('input', {
    staticClass: "input",
    attrs: {
      "type": "text",
      "placeholder": "Email"
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "icon is-small"
  }, [_c('i', {
    staticClass: "fa fa-envelope"
  })])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "field has-addons"
  }, [_c('p', {
    staticClass: "control has-icon is-expanded"
  }, [_c('input', {
    staticClass: "input",
    attrs: {
      "type": "password",
      "placeholder": "Password"
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "icon is-small"
  }, [_c('i', {
    staticClass: "fa fa-lock"
  })])]), _vm._v(" "), _c('p', {
    staticClass: "control"
  }, [_c('a', {
    staticClass: "button"
  }, [_vm._v("Forgot?")])])])
}]}

/***/ }),
/* 278 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "account-register"
  }, [_c('section', {
    staticClass: "hero is-light is-fullheight"
  }, [_c('div', {
    staticClass: "hero-head"
  }, [_c('header', {
    staticClass: "nav"
  }, [_c('div', {
    staticClass: "container"
  }, [_c('div', {
    staticClass: "nav-left"
  }, [_c('router-link', {
    staticClass: "nav-item",
    attrs: {
      "to": {
        name: 'home'
      }
    }
  }, [_c('img', {
    attrs: {
      "src": "https://placehold.it/64x64",
      "alt": "social-ui"
    }
  }), _vm._v(" social-ui\n            ")])], 1)])])]), _vm._v(" "), _c('div', {
    staticClass: "hero-body"
  }, [_c('div', {
    staticClass: "container is-fluid"
  }, [_c('div', {
    staticClass: "columns"
  }, [_c('div', {
    staticClass: "column is-4 is-offset-4"
  }, [_c('form', {
    staticClass: "box"
  }, [_c('p'), _vm._m(0), _vm._v(" "), _c('p'), _vm._v(" "), _c('hr'), _vm._v(" "), _vm._m(1), _vm._v(" "), _vm._m(2), _vm._v(" "), _vm._m(3), _vm._v(" "), _c('hr'), _vm._v(" "), _c('div', {
    staticClass: "field"
  }, [_c('p', {
    staticClass: "control"
  }, [_c('router-link', {
    staticClass: "button is-medium is-primary is-fullwidth",
    attrs: {
      "tag": "button",
      "to": {
        name: 'profile',
        params: {
          profileId: 'me'
        }
      }
    }
  }, [_vm._v("\n                    Create account\n                  ")])], 1)])]), _vm._v(" "), _c('div', {
    staticClass: "box has-text-centered"
  }, [_c('router-link', {
    staticClass: "button is-dark is-inverted is-fullwidth",
    attrs: {
      "to": {
        name: 'login'
      }
    }
  }, [_vm._v("\n                Have an account? Log in >\n              ")])], 1)])])])])]), _vm._v(" "), _c('sui-footer')], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "image is-16by9"
  }, [_c('img', {
    attrs: {
      "src": "https://placehold.it/160x90"
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "field"
  }, [_c('p', {
    staticClass: "control has-icon"
  }, [_c('input', {
    staticClass: "input",
    attrs: {
      "type": "text",
      "placeholder": "Email"
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "icon is-small"
  }, [_c('i', {
    staticClass: "fa fa-envelope"
  })])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "field is-grouped"
  }, [_c('p', {
    staticClass: "control has-icon is-expanded"
  }, [_c('input', {
    staticClass: "input",
    attrs: {
      "type": "password",
      "placeholder": "Password"
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "icon is-small"
  }, [_c('i', {
    staticClass: "fa fa-lock"
  })])]), _vm._v(" "), _c('p', {
    staticClass: "control is-expanded"
  }, [_c('input', {
    staticClass: "input",
    attrs: {
      "type": "password",
      "placeholder": "Confirm"
    }
  })])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "has-text-centered"
  }, [_c('small', [_vm._v("\n                  By registering you agree to our "), _c('br'), _vm._v(" "), _c('a', {}, [_c('strong', [_vm._v("terms of service")])])])])
}]}

/***/ }),
/* 279 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "profile-collection"
  }, [_c('div', {
    staticClass: "columns is-mobile"
  }, [_c('div', {
    staticClass: "column"
  }, [_vm._l((_vm.collectionList), function(collection) {
    return [_c('article', {
      staticClass: "media"
    }, [_vm._m(0, true), _vm._v(" "), _c('div', {
      staticClass: "media-content"
    }, [_c('div', {
      staticClass: "content max-lines--one-plus-three"
    }, [_c('p', [_c('strong', [_vm._v(_vm._s(collection.name))]), _vm._v(" "), _c('small', [_vm._v("(" + _vm._s(collection.counts.items) + " items)")]), _vm._v(" "), _c('br'), _vm._v("\n                " + _vm._s(collection.description) + "\n                "), _c('br')])])]), _vm._v(" "), _c('div', {
      staticClass: "media-right"
    })])]
  })], 2)])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('figure', {
    staticClass: "media-left"
  }, [_c('p', {
    staticClass: "image is-64x64"
  }, [_c('img', {
    attrs: {
      "src": "https://placehold.it/256x256"
    }
  })])])
}]}

/***/ }),
/* 280 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "profile-collection"
  }, [_c('div', {
    staticClass: "columns is-mobile"
  }, [_c('div', {
    staticClass: "column"
  }, [_vm._l((_vm.personList), function(person) {
    return [_c('article', {
      staticClass: "media"
    }, [_c('figure', {
      staticClass: "media-left"
    }, [_c('p', {
      staticClass: "image is-64x64 sui-avatar"
    }, [_c('img', {
      attrs: {
        "src": person.avatarUrl
      }
    })])]), _vm._v(" "), _c('div', {
      staticClass: "media-content"
    }, [_c('div', {
      staticClass: "content max-lines--one-plus-three"
    }, [_c('p', [_c('router-link', {
      attrs: {
        "to": {
          name: 'profile',
          params: {
            profileId: person.profileId
          }
        }
      }
    }, [_c('strong', [_vm._v(_vm._s(person.name))])]), _vm._v(" "), _c('br'), _vm._v(" "), _c('span', [_vm._v("\n                  " + _vm._s(person.bio) + "\n                ")])], 1)])]), _vm._v(" "), _c('div', {
      staticClass: "media-right"
    }, [_c('br'), _vm._v(" "), (!person.isMe) ? [(person.isFollowed) ? _c('button', {
      staticClass: "button is-outlined",
      on: {
        "click": function($event) {
          _vm.unfollowPerson(person)
        }
      }
    }, [_vm._v("following")]) : _c('button', {
      staticClass: "button is-primary",
      on: {
        "click": function($event) {
          _vm.followPerson(person)
        }
      }
    }, [_vm._v("follow")])] : _vm._e()], 2)])]
  })], 2)])])
},staticRenderFns: []}

/***/ }),
/* 281 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    staticClass: "columns is-mobile"
  }, [_c('div', {
    staticClass: "column is-1"
  }), _vm._v(" "), _c('div', {
    staticClass: "column"
  }, [_c('div', {
    staticClass: "image is-1by1 sui-avatar"
  }, [_c('img', {
    attrs: {
      "src": _vm.person.avatarUrl
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "column is-1"
  }), _vm._v(" "), _c('div', {
    staticClass: "column is-two-thirds content"
  }, [_c('p', [_c('span', {
    staticClass: "title is-bold"
  }, [_vm._v("\n          " + _vm._s(_vm.person.name) + "\n        ")]), _vm._v(" "), (!_vm.person.isMe) ? [_vm._v("\n           \n          "), (_vm.person.isFollowed) ? _c('button', {
    staticClass: "button is-outlined",
    on: {
      "click": function($event) {
        _vm.unfollowPerson(_vm.person)
      }
    }
  }, [_vm._v("following")]) : _c('button', {
    staticClass: "button is-primary",
    on: {
      "click": function($event) {
        _vm.followPerson(_vm.person)
      }
    }
  }, [_vm._v("follow")])] : _vm._e()], 2), _vm._v(" "), _c('p', [_c('span', {
    staticClass: "subtitle"
  }, [_c('small', [_vm._v(_vm._s(_vm.person.bio))])])])])])])
},staticRenderFns: []}

/***/ }),
/* 282 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [(!_vm.isLoading) ? _c(_vm.activeComponent, {
    tag: "component",
    attrs: {
      "profileId": _vm.profileId
    }
  }) : _vm._e()], 1)
},staticRenderFns: []}

/***/ }),
/* 283 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "bar"
  }, [_c('div', {
    staticClass: "bar-left"
  }, [_vm._t("left")], 2), _vm._v(" "), _c('div', {
    staticClass: "bar-center"
  }, [_vm._t("center")], 2), _vm._v(" "), _c('div', {
    staticClass: "bar-right"
  }, [_vm._t("right")], 2)])
},staticRenderFns: []}

/***/ }),
/* 284 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "profile-items"
  }, [_c('div', {
    staticClass: "columns is-multiline is-mobile"
  }, [(_vm.person.isMe) ? _c('div', {
    staticClass: "column is-one-third"
  }, [_c('router-link', {
    staticClass: "button sui-contribute-new-item",
    attrs: {
      "to": {
        name: 'Contribute'
      },
      "tag": "div"
    }
  }, [_c('div', {
    staticClass: "content"
  }, [_c('p', [_c('span', {
    staticClass: "icon"
  }, [_c('i', {
    staticClass: "fa fa-plus"
  })])]), _vm._v(" "), _c('p', [_vm._v("\n            ADD ITEM\n          ")])])])], 1) : _vm._e(), _vm._v(" "), _vm._l((_vm.itemList), function(item) {
    return [_c('div', {
      staticClass: "column is-one-third"
    }, [_c('div', {
      staticClass: "image is-1by1",
      on: {
        "click": function($event) {
          _vm.openModal(item)
        }
      }
    }, [_c('img', {
      attrs: {
        "src": item.content
      }
    })])])]
  })], 2), _vm._v(" "), _c('div', {
    staticClass: "modal",
    class: _vm.modalClass
  }, [_c('div', {
    staticClass: "modal-background",
    on: {
      "click": function($event) {
        _vm.closeModal()
      }
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "modal-content"
  }, [_c('div', {
    staticClass: "box"
  }, [_c('div', {
    staticClass: "columns"
  }, [_c('div', {
    staticClass: "column"
  }, [_c('div', {
    staticClass: "image is-1by1"
  }, [_c('img', {
    attrs: {
      "src": _vm.modalData.content
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "column"
  }, [_c('h1', {
    staticClass: "title"
  }, [_vm._v("\n              Some " + _vm._s(_vm.modalData.type) + "\n            ")]), _vm._v(" "), _c('h2', {
    staticClass: "subtitle"
  }, [_c('small', [_vm._v("\n                Curator: " + _vm._s(_vm.modalData.owner.name) + "\n                "), _c('br'), _vm._v("\n                ImageId: " + _vm._s(_vm.modalData.itemId) + "\n              ")])]), _vm._v(" "), _c('p', [_c('small', [_vm._v("\n                " + _vm._s(_vm.modalData.caption) + "\n              ")])])])])])]), _vm._v(" "), _c('button', {
    staticClass: "modal-close",
    on: {
      "click": function($event) {
        _vm.closeModal()
      }
    }
  })])])
},staticRenderFns: []}

/***/ }),
/* 285 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('p', {
    staticClass: "control"
  }, [_c('span', {
    staticClass: "select"
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.selectedLayout),
      expression: "selectedLayout"
    }],
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.selectedLayout = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }
    }
  }, [_vm._l((_vm.layoutStyles), function(layoutStyle) {
    return [_c('option', {
      domProps: {
        "value": layoutStyle
      }
    }, [_vm._v(_vm._s(layoutStyle))])]
  })], 2)])])])
},staticRenderFns: []}

/***/ }),
/* 286 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "contribute"
  }, [_c('section', {
    staticClass: "hero is-fullheight is-white sui-contribute"
  }, [_c('div', {
    staticClass: "hero-head sui-contribute-header"
  }, [_c('bar', {
    staticClass: "container"
  }, [_c('div', {
    staticClass: "bar-content",
    slot: "left"
  }, [_c('router-link', {
    staticClass: "navbar-item",
    attrs: {
      "to": {
        name: 'home'
      }
    }
  }, [_c('img', {
    attrs: {
      "src": "https://placehold.it/64x64",
      "alt": "social-ui"
    }
  }), _vm._v(" social-ui\n          ")])], 1), _vm._v(" "), _c('div', {
    staticClass: "bar-content",
    slot: "right"
  }, [_c('div', {
    staticClass: "navbar-item"
  }, [_c('div', {
    staticClass: "field"
  }, [_c('p', {
    staticClass: "control"
  }, [_c('a', {
    staticClass: "button is-primary",
    on: {
      "click": _vm.contributeContent
    }
  }, [_vm._v("\n                  POST\n                ")])])])])])])], 1), _vm._v(" "), _c('div', {
    staticClass: "hero-body"
  }, [_c('div', {
    staticClass: "container"
  }, [_c('form', {
    on: {
      "submit": function($event) {
        $event.preventDefault();
      }
    }
  }, [_c('div', {
    staticClass: "field"
  }, [_c('p', {
    staticClass: "control"
  }, [_c('textarea', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.caption),
      expression: "caption"
    }],
    ref: "caption",
    staticClass: "textarea",
    attrs: {
      "placeholder": "Type a caption"
    },
    domProps: {
      "value": (_vm.caption)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.caption = $event.target.value
      }
    }
  })])]), _vm._v(" "), _c('nav', {
    staticClass: "level is-mobile"
  }, [_c('div', {
    staticClass: "level-left"
  }, [_c('div', {
    staticClass: "level-item"
  }, [_c('div', {
    staticClass: "field has-addons"
  }, [_c('p', {
    staticClass: "control"
  }, [_c('button', {
    staticClass: "button is-white",
    attrs: {
      "disabled": !_vm.canAddImages
    },
    on: {
      "click": _vm.addAttachmentImage
    }
  }, [_vm._m(0)])]), _vm._v(" "), _c('p', {
    staticClass: "control"
  }, [_c('button', {
    staticClass: "button is-white",
    attrs: {
      "disabled": !_vm.canAddVideos
    },
    on: {
      "click": _vm.addAttachmentVideo
    }
  }, [_vm._m(1)])]), _vm._v(" "), _c('p', {
    staticClass: "control"
  }, [_c('button', {
    staticClass: "button is-white",
    attrs: {
      "disabled": !_vm.canAddLinks
    },
    on: {
      "click": _vm.addAttachmentLink
    }
  }, [_vm._m(2)])]), _vm._v(" "), _vm._m(3)])])]), _vm._v(" "), _c('div', {
    staticClass: "level-center"
  }, [_c('div', {
    staticClass: "level-item"
  }, [_c('div', {
    staticClass: "field has-addons"
  }, [_c('p', {
    staticClass: "control"
  }, [_c('button', {
    staticClass: "button is-white",
    on: {
      "click": _vm.addHashTag
    }
  }, [_vm._m(4)])]), _vm._v(" "), _c('p', {
    staticClass: "control"
  }, [_c('button', {
    staticClass: "button is-white",
    on: {
      "click": _vm.addMention
    }
  }, [_vm._m(5)])])])])])]), _vm._v(" "), _c('transition-group', {
    staticClass: "columns is-mobile attachment-preview",
    attrs: {
      "name": "attachments",
      "enter-active-class": "animated fadeIn",
      "leave-active-class": "animated fadeOut",
      "tag": "div"
    }
  }, [_vm._l((_vm.attachmentList), function(attachment, $index) {
    return [(attachment.type === 'image' || attachment.type === 'video') ? _c('div', {
      key: $index,
      staticClass: "column has-text-centered"
    }, [_c('div', {
      staticClass: "image is-128x128"
    }, [_c('img', {
      attrs: {
        "src": attachment.url
      }
    })]), _vm._v(" "), _c('a', {
      staticClass: "button is-danger is-outlined",
      on: {
        "click": function($event) {
          _vm.removeAttachment($index)
        }
      }
    }, [_c('span', {
      staticClass: "icon is-small"
    }, [_c('i', {
      staticClass: "fa fa-times"
    })]), _vm._v(" "), _c('span', [_vm._v("\n                  REMOVE\n                ")])])]) : _vm._e(), _vm._v(" "), (attachment.type === 'link') ? _c('div', {
      key: $index,
      staticClass: "column is-offset-3-tablet is-half-tablet has-text-centered"
    }, [_c('article', {
      staticClass: "media",
      staticStyle: {
        "min-height": "128px"
      }
    }, [_c('figure', {
      staticClass: "media-left"
    }, [_c('p', {
      staticClass: "image is-64x64"
    }, [_c('img', {
      attrs: {
        "src": attachment.imageUrl
      }
    })])]), _vm._v(" "), _c('div', {
      staticClass: "media-content"
    }, [_c('div', {
      staticClass: "content max-lines--one-plus-three"
    }, [_c('p', [_c('strong', [_vm._v(_vm._s(attachment.url))]), _vm._v(" "), _c('br'), _vm._v("\n                      " + _vm._s(attachment.caption) + "\n                    ")])]), _vm._v(" "), _c('hr')])]), _vm._v(" "), _c('a', {
      staticClass: "button is-danger is-outlined",
      on: {
        "click": function($event) {
          _vm.removeAttachment($index)
        }
      }
    }, [_c('span', {
      staticClass: "icon is-small"
    }, [_c('i', {
      staticClass: "fa fa-times"
    })]), _vm._v(" "), _c('span', [_vm._v("\n                  REMOVE\n                ")])])]) : _vm._e()]
  }), _vm._v(" "), _vm._l((6), function(n) {
    return (!_vm.attachmentListType || _vm.attachmentListType !== 'link') ? _c('div', {
      key: 'ghost-' + n,
      staticClass: "column"
    }) : _vm._e()
  })], 2)], 1)])])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "icon is-small"
  }, [_c('i', {
    staticClass: "fa fa-picture-o"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "icon is-small"
  }, [_c('i', {
    staticClass: "fa fa-film"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "icon is-small"
  }, [_c('i', {
    staticClass: "fa fa-link"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "control"
  }, [_c('button', {
    staticClass: "button is-white",
    attrs: {
      "disabled": ""
    }
  }, [_c('span', {
    staticClass: "icon is-small"
  }, [_c('i', {
    staticClass: "fa fa-map-marker"
  })])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "icon is-small"
  }, [_c('i', {
    staticClass: "fa fa-hashtag"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "icon is-small"
  }, [_c('i', {
    staticClass: "fa fa-at"
  })])
}]}

/***/ }),
/* 287 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "profile"
  }, [_c('sui-header'), _vm._v(" "), _c('div', {
    staticClass: "section"
  }, [_c('div', {
    staticClass: "container"
  }, [_c('div', {
    staticClass: "columns"
  }, [_c('div', {
    staticClass: "column"
  }, [_vm._l((_vm.chatRoomListing), function(chatRoom) {
    return [_c('article', {
      staticClass: "media"
    }, [_vm._m(0, true), _vm._v(" "), _c('div', {
      staticClass: "media-content"
    }, [_c('div', {
      staticClass: "content max-lines--one-plus-three"
    }, [_c('p', [_c('router-link', {
      attrs: {
        "to": {
          name: 'chatroom',
          params: {
            chatRoomId: chatRoom.chatRoomId
          }
        }
      }
    }, [_c('strong', [_vm._v(_vm._s(chatRoom.title))])]), _vm._v(" "), _c('small', [_vm._v("(" + _vm._s(chatRoom.counts.participants) + " members)")]), _vm._v(" "), _c('br'), _vm._v(" "), (chatRoom.preview) ? _c('span', [_vm._v("\n                      " + _vm._s(chatRoom.preview.content) + "\n                    ")]) : _c('span', [_c('small', [_c('i', [_vm._v("no messages")])])])], 1)])]), _vm._v(" "), _c('div', {
      staticClass: "media-right"
    }, [(chatRoom.preview) ? _c('p', [_c('strong', [_vm._v("\n                    " + _vm._s(_vm.timeFromTimestamp(chatRoom.preview.timestamp)) + "\n                  ")]), _vm._v(" "), _c('br'), _vm._v(" "), _c('small', [_vm._v("\n                    " + _vm._s(_vm.dateFromTimestamp(chatRoom.preview.timestamp)) + "\n                  ")])]) : _vm._e()])])]
  })], 2)])])]), _vm._v(" "), _c('sui-footer')], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('figure', {
    staticClass: "media-left"
  }, [_c('p', {
    staticClass: "image is-64x64 sui-avatar"
  }, [_c('img', {
    attrs: {
      "src": "http://placehold.it/64x64"
    }
  })])])
}]}

/***/ }),
/* 288 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "profile-collection"
  }, [_c('div', {
    staticClass: "columns is-mobile"
  }, [_c('div', {
    staticClass: "column"
  }, [_vm._l((_vm.personList), function(person) {
    return [_c('article', {
      staticClass: "media"
    }, [_c('figure', {
      staticClass: "media-left"
    }, [_c('p', {
      staticClass: "image is-64x64 sui-avatar"
    }, [_c('img', {
      attrs: {
        "src": person.avatarUrl
      }
    })])]), _vm._v(" "), _c('div', {
      staticClass: "media-content"
    }, [_c('div', {
      staticClass: "content max-lines--one-plus-three"
    }, [_c('p', [_c('router-link', {
      attrs: {
        "to": {
          name: 'profile',
          params: {
            profileId: person.profileId
          }
        }
      }
    }, [_c('strong', [_vm._v(_vm._s(person.name))])]), _vm._v(" "), _c('br'), _vm._v(" "), _c('span', [_vm._v("\n                  " + _vm._s(person.bio) + "\n                ")])], 1)])]), _vm._v(" "), _c('div', {
      staticClass: "media-right"
    }, [_c('br'), _vm._v(" "), (!person.isMe) ? [(person.isFollowed) ? _c('button', {
      staticClass: "button is-outlined",
      on: {
        "click": function($event) {
          _vm.unfollowPerson(person)
        }
      }
    }, [_vm._v("following")]) : _c('button', {
      staticClass: "button is-primary",
      on: {
        "click": function($event) {
          _vm.followPerson(person)
        }
      }
    }, [_vm._v("follow")])] : _vm._e()], 2)])]
  })], 2)])])
},staticRenderFns: []}

/***/ }),
/* 289 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "profile"
  }, [_c('sui-header'), _vm._v(" "), _c('div', {
    staticClass: "section"
  }, [_c('div', {
    staticClass: "container"
  }, [_c('div', {
    staticClass: "columns"
  }, [_c('div', {
    staticClass: "column is-one-third"
  }, [_c('div', {
    staticClass: "is-hidden-mobile"
  }, [_c('profile-header-narrow', {
    attrs: {
      "person": _vm.person
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "is-hidden-tablet"
  }, [_c('profile-header-mobile', {
    attrs: {
      "person": _vm.person
    }
  })], 1)]), _vm._v(" "), _c('div', {
    staticClass: "column is-two-thirds"
  }, [_c('div', {
    staticClass: "columns"
  }, [_c('div', {
    staticClass: "column level is-mobile"
  }, [_c('router-link', {
    staticClass: "level-item has-text-centered",
    attrs: {
      "to": {
        name: 'profile/items',
        params: {
          profileId: _vm.profileId
        }
      }
    }
  }, [_c('div', [_c('p', [_vm._v(_vm._s(_vm.person.stats.item))]), _vm._v(" "), _c('p', [_vm._v("Items")])])]), _vm._v(" "), _c('router-link', {
    staticClass: "level-item has-text-centered",
    attrs: {
      "to": {
        name: 'profile/collections',
        params: {
          profileId: _vm.profileId
        }
      }
    }
  }, [_c('div', [_c('p', [_vm._v(_vm._s(_vm.person.stats.collection))]), _vm._v(" "), _c('p', [_vm._v("Collections")])])]), _vm._v(" "), _c('router-link', {
    staticClass: "level-item has-text-centered",
    attrs: {
      "to": {
        name: 'profile/following',
        params: {
          profileId: _vm.profileId
        }
      }
    }
  }, [_c('div', [_c('p', [_vm._v(_vm._s(_vm.person.stats.followee))]), _vm._v(" "), _c('p', [_vm._v("Following")])])]), _vm._v(" "), _c('router-link', {
    staticClass: "level-item has-text-centered",
    attrs: {
      "to": {
        name: 'profile/followers',
        params: {
          profileId: _vm.profileId
        }
      }
    }
  }, [_c('div', [_c('p', [_vm._v(_vm._s(_vm.person.stats.follower))]), _vm._v(" "), _c('p', [_vm._v("Followers")])])])], 1)]), _vm._v(" "), _c('router-view', {
    attrs: {
      "person": _vm.person
    }
  })], 1)])])]), _vm._v(" "), _c('sui-footer')], 1)
},staticRenderFns: []}

/***/ }),
/* 290 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    staticClass: "columns"
  }, [_c('div', {
    staticClass: "column is-2"
  }), _vm._v(" "), _c('div', {
    staticClass: "column"
  }, [_c('div', {
    staticClass: "image is-1by1 sui-avatar"
  }, [_c('img', {
    attrs: {
      "src": _vm.person.avatarUrl
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "column is-2"
  })]), _vm._v(" "), _c('div', {
    staticClass: "columns"
  }, [_c('div', {
    staticClass: "column content"
  }, [_c('p', [_c('span', {
    staticClass: "title is-bold"
  }, [_vm._v("\n          " + _vm._s(_vm.person.name) + "\n        ")])]), _vm._v(" "), (!_vm.person.isMe) ? _c('p', [(_vm.person.isFollowed) ? _c('button', {
    staticClass: "button is-medium is-fullwidth is-outlined",
    on: {
      "click": function($event) {
        _vm.unfollowPerson(_vm.person)
      }
    }
  }, [_vm._v("following")]) : _c('button', {
    staticClass: "button is-primary is-medium is-fullwidth",
    on: {
      "click": function($event) {
        _vm.followPerson(_vm.person)
      }
    }
  }, [_vm._v("follow")])]) : _vm._e(), _vm._v(" "), _c('p', [_c('span', {
    staticClass: "subtitle"
  }, [_c('small', [_vm._v(_vm._s(_vm.person.bio))])])])])])])
},staticRenderFns: []}

/***/ }),
/* 291 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chatroom"
  }, [_c('section', {
    staticClass: "hero is-fullheight is-light sui-messages"
  }, [_c('div', {
    staticClass: "hero-head sui-chat-header"
  }, [_c('bar', {
    staticClass: "container"
  }, [_c('div', {
    staticClass: "bar-content",
    slot: "left"
  }, [_c('router-link', {
    staticClass: "navbar-item",
    attrs: {
      "to": {
        name: 'home'
      }
    }
  }, [_c('img', {
    attrs: {
      "src": "https://placehold.it/64x64",
      "alt": "social-ui"
    }
  }), _vm._v(" social-ui\n          ")])], 1), _vm._v(" "), _c('div', {
    staticClass: "bar-content",
    slot: "center"
  }, [_c('div', {
    staticClass: "nav-item"
  }, [_c('p', {
    staticClass: "title"
  }, [_vm._v("\n              " + _vm._s(_vm.chatRoom.title) + "\n            ")])])]), _vm._v(" "), _c('div', {
    staticClass: "bar-content",
    slot: "right"
  }, [_c('div', {
    staticClass: "nav-item is-pulled-right"
  }, [_c('button', {
    staticClass: "button is-white",
    on: {
      "click": function($event) {
        _vm.openModal()
      }
    }
  }, [_c('span', {
    staticClass: "icon"
  }, [_c('i', {
    staticClass: "fa fa-question-circle"
  })])])])])])], 1), _vm._v(" "), _c('div', {
    staticClass: "hero-body"
  }, [_c('div', {
    staticClass: "container"
  }, [(_vm.countMessages === 0) ? _c('div', {
    staticClass: "columns"
  }, [_vm._m(0)]) : _c('div', {
    staticClass: "columns"
  }, [_c('div', {
    staticClass: "column"
  }, [_vm._l((_vm.chatRoom.messages), function(message) {
    return [_c('article', {
      staticClass: "media"
    }, [_c('figure', {
      staticClass: "media-left"
    }, [(!message.person.isMe) ? _c('p', {
      staticClass: "image is-64x64 sui-avatar"
    }, [_c('img', {
      attrs: {
        "src": message.person.avatarUrl
      }
    })]) : _vm._e()]), _vm._v(" "), _c('div', {
      staticClass: "media-content"
    }, [_c('div', {
      staticClass: "content box"
    }, [_c('p', [_c('strong', [_vm._v(_vm._s(message.person.name))]), _vm._v(" "), _c('small', [_vm._v(_vm._s(message.person.handle))]), _vm._v(" "), _c('small', [_vm._v(_vm._s(_vm.timeAgoFromTimestamp(message.timestamp)))]), _vm._v(" "), _c('br'), _vm._v("\n                      " + _vm._s(message.content) + "\n                    ")])])]), _vm._v(" "), _c('div', {
      staticClass: "media-right"
    }, [(message.person.isMe) ? _c('p', {
      staticClass: "image is-64x64 sui-avatar"
    }, [_c('img', {
      attrs: {
        "src": message.person.avatarUrl
      }
    })]) : _vm._e()])])]
  })], 2)]), _vm._v(" "), _vm._m(1)])]), _vm._v(" "), _c('div', {
    staticClass: "hero-foot sui-chat-footer"
  }, [_c('div', {
    staticClass: "sui-chat-footer-form"
  }, [_c('div', {
    staticClass: "container"
  }, [_c('div', {
    staticClass: "field is-grouped is-horizontal"
  }, [_vm._m(2), _vm._v(" "), _c('p', {
    staticClass: "control is-expanded"
  }, [_c('textarea', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.inputMessage),
      expression: "inputMessage"
    }],
    staticClass: "textarea",
    attrs: {
      "type": "text",
      "placeholder": "Type a message"
    },
    domProps: {
      "value": (_vm.inputMessage)
    },
    on: {
      "keyup": function($event) {
        if (_vm._k($event.keyCode, "enter", 13)) { return null; }
        _vm.sendMessage(_vm.inputMessage)
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.inputMessage = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "control"
  }, [_c('button', {
    staticClass: "button is-medium",
    class: _vm.sendMessageClass,
    on: {
      "click": function($event) {
        _vm.sendMessage(_vm.inputMessage)
      }
    }
  }, [_vm._m(3)])])])])])])]), _vm._v(" "), _c('div', {
    staticClass: "modal",
    class: _vm.modalClass
  }, [_c('div', {
    staticClass: "modal-background",
    on: {
      "click": function($event) {
        _vm.closeModal()
      }
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "modal-content"
  }, [_c('div', {
    staticClass: "box"
  }, [_c('div', {
    staticClass: "columns"
  }, [_c('div', {
    staticClass: "column"
  }, [_c('h3', {
    staticClass: "title is-5"
  }, [_vm._v("\n              Participants\n            ")]), _vm._v(" "), _c('p', [_vm._l((_vm.chatRoom.participants), function(person) {
    return [_c('span', {
      staticClass: "image is-32x32 sui-avatar sui-avatar--flow"
    }, [_c('img', {
      attrs: {
        "src": person.avatarUrl
      }
    })])]
  })], 2)])])])]), _vm._v(" "), _c('button', {
    staticClass: "modal-close",
    on: {
      "click": function($event) {
        _vm.closeModal()
      }
    }
  })])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "column"
  }, [_c('div', {
    staticClass: "box has-text-centered"
  }, [_vm._v("\n              No messages\n            ")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "columns"
  }, [_c('div', {
    staticClass: "column"
  }, [_c('div', {
    attrs: {
      "id": "sui-messages-bottom"
    }
  })])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "control"
  }, [_c('button', {
    staticClass: "button is-medium is-white"
  }, [_c('span', {
    staticClass: "icon is-small"
  }, [_c('i', {
    staticClass: "fa fa-plus"
  })])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "icon is-small"
  }, [_c('i', {
    staticClass: "fa fa-send"
  })])
}]}

/***/ }),
/* 292 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "profile"
  }, [_c('sui-header'), _vm._v(" "), _c('div', {
    staticClass: "section"
  }, [_c('div', {
    staticClass: "container"
  }, [_c('div', {
    staticClass: "is-hidden-mobile"
  }, [_c('profile-header-wide', {
    attrs: {
      "person": _vm.person
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "is-hidden-tablet"
  }, [_c('profile-header-mobile', {
    attrs: {
      "person": _vm.person
    }
  })], 1)]), _vm._v(" "), _vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "container"
  }, [_c('div', {
    staticClass: "columns"
  }, [_c('div', {
    staticClass: "column level is-mobile"
  }, [_c('router-link', {
    staticClass: "level-item has-text-centered",
    attrs: {
      "to": {
        name: 'profile/items',
        params: {
          profileId: _vm.profileId
        }
      }
    }
  }, [_c('div', [_c('p', [_vm._v(_vm._s(_vm.person.stats.item))]), _vm._v(" "), _c('p', [_vm._v("Items")])])]), _vm._v(" "), _c('router-link', {
    staticClass: "level-item has-text-centered",
    attrs: {
      "to": {
        name: 'profile/collections',
        params: {
          profileId: _vm.profileId
        }
      }
    }
  }, [_c('div', [_c('p', [_vm._v(_vm._s(_vm.person.stats.collection))]), _vm._v(" "), _c('p', [_vm._v("Collections")])])]), _vm._v(" "), _c('router-link', {
    staticClass: "level-item has-text-centered",
    attrs: {
      "to": {
        name: 'profile/following',
        params: {
          profileId: _vm.profileId
        }
      }
    }
  }, [_c('div', [_c('p', [_vm._v(_vm._s(_vm.person.stats.followee))]), _vm._v(" "), _c('p', [_vm._v("Following")])])]), _vm._v(" "), _c('router-link', {
    staticClass: "level-item has-text-centered",
    attrs: {
      "to": {
        name: 'profile/followers',
        params: {
          profileId: _vm.profileId
        }
      }
    }
  }, [_c('div', [_c('p', [_vm._v(_vm._s(_vm.person.stats.follower))]), _vm._v(" "), _c('p', [_vm._v("Followers")])])])], 1)])]), _vm._v(" "), _c('div', {
    staticClass: "container"
  }, [_c('router-view', {
    attrs: {
      "person": _vm.person
    }
  })], 1)]), _vm._v(" "), _c('sui-footer')], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "container"
  }, [_c('hr')])
}]}

/***/ }),
/* 293 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "header-wrapper"
  }, [_c('div', {
    staticClass: "container"
  }, [_c('nav', {
    staticClass: "navbar"
  }, [_c('div', {
    staticClass: "navbar-brand"
  }, [_c('router-link', {
    staticClass: "navbar-item",
    attrs: {
      "to": {
        name: 'home'
      }
    }
  }, [_c('img', {
    attrs: {
      "src": "https://placehold.it/64x64",
      "alt": "social-ui"
    }
  }), _vm._v(" social-ui\n        ")]), _vm._v(" "), _c('div', {
    staticClass: "navbar-burger",
    class: _vm.navMenuClass,
    on: {
      "click": _vm.toggleMenu
    }
  }, [_c('span'), _vm._v(" "), _c('span'), _vm._v(" "), _c('span')])], 1), _vm._v(" "), _c('div', {
    staticClass: "navbar-menu",
    class: _vm.navMenuClass
  }, [_c('div', {
    staticClass: "navbar-start"
  }), _vm._v(" "), _c('div', {
    staticClass: "navbar-middle"
  }, [_c('span', {
    staticClass: "nav-item is-hidden-mobile"
  }, [_vm._v("\n            Profile style  \n            "), _c('profile-switcher')], 1)]), _vm._v(" "), _c('div', {
    staticClass: "navbar-end"
  }, [_c('router-link', {
    staticClass: "navbar-item",
    attrs: {
      "to": {
        name: 'chatroomListing'
      }
    }
  }, [_c('span', {
    staticClass: "icon"
  }, [_c('i', {
    staticClass: "fa fa-envelope"
  })]), _vm._v("\n             \n            "), _c('span', [_vm._v("\n              Messages\n            ")])]), _vm._v(" "), _c('router-link', {
    staticClass: "navbar-item",
    attrs: {
      "to": {
        name: 'profile',
        params: {
          profileId: 'me'
        }
      }
    }
  }, [_c('span', {
    staticClass: "icon"
  }, [_c('i', {
    staticClass: "fa fa-user"
  })]), _vm._v("\n             \n            "), _c('span', [_vm._v("\n              Profile\n            ")])])], 1)])])])])
},staticRenderFns: []}

/***/ }),
/* 294 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "home"
  }, [_c('nav', {
    staticClass: "navbar has-shadow"
  }, [_c('div', {
    staticClass: "container"
  }, [_c('div', {
    staticClass: "navbar-brand"
  }, [_c('a', {
    staticClass: "nav-item"
  }, [_vm._v("\n          social-ui\n        ")]), _vm._v(" "), _c('span', {
    staticClass: "nav-item is-hidden-tablet"
  }, [_c('router-link', {
    staticClass: "button is-primary is-outlined",
    attrs: {
      "to": {
        name: 'login'
      }
    }
  }, [_c('span', [_vm._v("Login")])])], 1), _vm._v(" "), _c('span', {
    staticClass: "nav-item is-hidden-tablet"
  }, [_c('router-link', {
    staticClass: "button is-primary",
    attrs: {
      "to": {
        name: 'register'
      }
    }
  }, [_c('span', [_vm._v("Register")])])], 1)]), _vm._v(" "), _c('div', {
    staticClass: "navbar-menu"
  }, [_c('div', {
    staticClass: "navbar-end"
  }, [_c('span', {
    staticClass: "nav-item"
  }, [_c('router-link', {
    staticClass: "button is-primary is-outlined",
    attrs: {
      "to": {
        name: 'login'
      }
    }
  }, [_c('span', [_vm._v("Login")])])], 1), _vm._v(" "), _c('span', {
    staticClass: "nav-item"
  }, [_c('router-link', {
    staticClass: "button is-primary",
    attrs: {
      "to": {
        name: 'register'
      }
    }
  }, [_c('span', [_vm._v("Register")])])], 1)])])])]), _vm._v(" "), _vm._m(0), _vm._v(" "), _vm._m(1), _vm._v(" "), _vm._m(2), _vm._v(" "), _vm._m(3), _vm._v(" "), _vm._m(4), _vm._v(" "), _c('section', {
    staticClass: "hero is-primary is-medium"
  }, [_c('div', {
    staticClass: "hero-body"
  }, [_c('div', {
    staticClass: "container has-text-centered"
  }, [_c('h1', {
    staticClass: "title"
  }, [_vm._v("\n          Try it now\n        ")]), _vm._v(" "), _c('h2', {
    staticClass: "subtitle"
  }, [_vm._v("\n          Unlock awesomeness\n        ")]), _vm._v(" "), _c('router-link', {
    staticClass: "button is-primary is-medium is-inverted",
    attrs: {
      "to": {
        name: 'profile',
        params: {
          profileId: 'me'
        }
      }
    }
  }, [_vm._v("\n          Get started\n        ")])], 1)])]), _vm._v(" "), _c('sui-footer')], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    staticClass: "hero is-primary is-medium"
  }, [_c('div', {
    staticClass: "hero-body"
  }, [_c('div', {
    staticClass: "container has-text-centered"
  }, [_c('h1', {
    staticClass: "title"
  }, [_vm._v("\n          Awesome new social site\n        ")]), _vm._v(" "), _c('h2', {
    staticClass: "subtitle"
  }, [_vm._v("\n          where people can be social on a site\n        ")])])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    staticClass: "section"
  }, [_c('div', {
    staticClass: "container"
  }, [_c('div', {
    staticClass: "columns is-multiline"
  }, [_c('div', {
    staticClass: "column is-one-third has-text-centered"
  }, [_c('div', {
    staticClass: "content"
  }, [_c('p'), _c('div', {
    staticClass: "image is-16by9"
  }, [_c('img', {
    attrs: {
      "src": "https://placehold.it/160x90"
    }
  })]), _vm._v(" "), _c('p'), _vm._v(" "), _c('p', [_vm._v("\n              Lorem ipsum dolor sit amet, consectetur adipiscing elit. Duis efficitur nisi non diam convallis laoreet.\n            ")])])]), _vm._v(" "), _c('div', {
    staticClass: "column is-one-third has-text-centered"
  }, [_c('div', {
    staticClass: "content"
  }, [_c('p'), _c('div', {
    staticClass: "image is-16by9"
  }, [_c('img', {
    attrs: {
      "src": "https://placehold.it/160x90"
    }
  })]), _vm._v(" "), _c('p'), _vm._v(" "), _c('p', [_vm._v("\n              Interdum et malesuada fames ac ante ipsum primis in faucibus. Maecenas vitae finibus risus.\n            ")])])]), _vm._v(" "), _c('div', {
    staticClass: "column is-one-third has-text-centered"
  }, [_c('div', {
    staticClass: "content"
  }, [_c('p'), _c('div', {
    staticClass: "image is-16by9"
  }, [_c('img', {
    attrs: {
      "src": "https://placehold.it/160x90"
    }
  })]), _vm._v(" "), _c('p'), _vm._v(" "), _c('p', [_vm._v("\n              Donec euismod lacus ac ipsum placerat pretium ac sed felis. Donec et mauris id augue convallis efficitur in nec purus.\n            ")])])])])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    staticClass: "hero is-light"
  }, [_c('div', {
    staticClass: "hero-body"
  }, [_c('div', {
    staticClass: "container"
  }, [_c('div', {
    staticClass: "columns"
  }, [_c('div', {
    staticClass: "column is-half"
  }, [_c('div', {
    staticClass: "image is-2by1"
  }, [_c('img', {
    attrs: {
      "src": "https://placehold.it/160x80"
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "column is-one-third is-offset-1"
  }, [_c('h1', {
    staticClass: "title"
  }, [_vm._v("\n              Aenean neque tellus\n            ")]), _vm._v(" "), _c('h2', {
    staticClass: "subtitle"
  }, [_vm._v("\n              Maecenas ac leo ac dolor suscipit pellentesque.\n              Aenean massa sem, scelerisque vitae odio sed, scelerisque auctor odio.\n              Pellentesque tristique metus ac sollicitudin sagittis.\n              Maecenas ut leo in nisl tincidunt fermentum ut at odio.\n            ")]), _vm._v(" "), _c('p', [_c('button', {
    staticClass: "button is-primary"
  }, [_vm._v("Get started")])])])])])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    staticClass: "hero is-dark"
  }, [_c('div', {
    staticClass: "hero-body"
  }, [_c('div', {
    staticClass: "container"
  }, [_c('div', {
    staticClass: "columns is-tablet-reversed"
  }, [_c('div', {
    staticClass: "column is-half is-offset-2"
  }, [_c('div', {
    staticClass: "image is-2by1"
  }, [_c('img', {
    attrs: {
      "src": "https://placehold.it/160x80"
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "column is-one-third"
  }, [_c('h1', {
    staticClass: "title"
  }, [_vm._v("\n              Aenean neque tellus\n            ")]), _vm._v(" "), _c('h2', {
    staticClass: "subtitle"
  }, [_vm._v("\n              Ac sollicitudin sagittis pellentesque tristique metus.\n              Tincidunt fermentum ut at odio maecenas ut leo in nisl.\n              Odio odio aenean sed, scelerisque auctor massa sem, scelerisque vitae.\n              Suscipit ac dolor Maecenas ac leo pellentesque.\n            ")]), _vm._v(" "), _c('p', [_c('button', {
    staticClass: "button is-primary is-outlined"
  }, [_vm._v("Learn more")])])])])])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    staticClass: "hero"
  }, [_c('div', {
    staticClass: "hero-body"
  }, [_c('div', {
    staticClass: "container"
  }, [_c('div', {
    staticClass: "columns is-multiline is-mobile"
  }, [_c('div', {
    staticClass: "column is-half-mobile"
  }, [_c('div', {
    staticClass: "image is-16by9"
  }, [_c('img', {
    attrs: {
      "src": "https://placehold.it/160x90"
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "column is-half-mobile"
  }, [_c('div', {
    staticClass: "image is-16by9"
  }, [_c('img', {
    attrs: {
      "src": "https://placehold.it/160x90"
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "column is-half-mobile"
  }, [_c('div', {
    staticClass: "image is-16by9"
  }, [_c('img', {
    attrs: {
      "src": "https://placehold.it/160x90"
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "column is-half-mobile"
  }, [_c('div', {
    staticClass: "image is-16by9"
  }, [_c('img', {
    attrs: {
      "src": "https://placehold.it/160x90"
    }
  })])])])])])])
}]}

/***/ }),
/* 295 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "app"
    }
  }, [_c('router-view')], 1)
},staticRenderFns: []}

/***/ }),
/* 296 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    staticClass: "columns is-mobile"
  }, [_c('div', {
    staticClass: "column"
  }, [_c('div', {
    staticClass: "image is-1by1 sui-avatar"
  }, [_c('img', {
    attrs: {
      "src": _vm.person.avatarUrl
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "column is-two-thirds"
  }, [_c('h1', {
    staticClass: "title is-bold"
  }, [_vm._v("\n        " + _vm._s(_vm.person.name) + "\n      ")]), _vm._v(" "), (!_vm.person.isMe) ? _c('p', [(_vm.person.isFollowed) ? _c('button', {
    staticClass: "button is-outlined is-fullwidth",
    on: {
      "click": function($event) {
        _vm.unfollowPerson(_vm.person)
      }
    }
  }, [_vm._v("following")]) : _c('button', {
    staticClass: "button is-primary is-fullwidth",
    on: {
      "click": function($event) {
        _vm.followPerson(_vm.person)
      }
    }
  }, [_vm._v("follow")])]) : _vm._e()])]), _vm._v(" "), _c('div', {
    staticClass: "columns"
  }, [_c('div', {
    staticClass: "column"
  }, [_c('p', [_c('span', {
    staticClass: "subtitle"
  }, [_c('small', [_vm._v(_vm._s(_vm.person.bio))])])])])])])
},staticRenderFns: []}

/***/ }),
/* 297 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('footer', {
    staticClass: "footer sui-footer"
  }, [_c('div', {
    staticClass: "container"
  }, [_c('div', {
    staticClass: "has-text-centered"
  }, [_c('p', [_c('router-link', {
    attrs: {
      "to": {
        name: 'home'
      }
    }
  }, [_c('strong', [_vm._v("social-ui")])]), _vm._v("\n        by\n        "), _c('a', {
    attrs: {
      "href": "https://aaron-tay.github.io",
      "target": "_blank"
    }
  }, [_vm._v("aaron-tay")])], 1), _vm._v(" "), _vm._m(0), _vm._v(" "), _vm._m(1)])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_vm._v("\n        Developed using\n        "), _c('a', {
    attrs: {
      "href": "https://vuejs.org",
      "target": "_blank"
    }
  }, [_vm._v("vuejs")]), _vm._v(",\n        "), _c('a', {
    attrs: {
      "href": "http://bulma.io",
      "target": "_blank"
    }
  }, [_vm._v("bulma.io")]), _vm._v(",\n        "), _c('a', {
    attrs: {
      "href": "http://placehod.it",
      "target": "_blank"
    }
  }, [_vm._v("placehold.it")]), _vm._v(",\n        "), _c('a', {
    attrs: {
      "href": "http://chancejs.com",
      "target": "_blank"
    }
  }, [_vm._v("chance")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_vm._v("\n        View it on\n        "), _c('a', {
    attrs: {
      "href": "https://github.com/aaron-tay/social.ui",
      "target": "_blank"
    }
  }, [_vm._v("GitHub")])])
}]}

/***/ }),
/* 298 */,
/* 299 */,
/* 300 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex_router_sync__ = __webpack_require__(160);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex_router_sync___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_vuex_router_sync__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__App__ = __webpack_require__(159);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__App___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__App__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__router__ = __webpack_require__(157);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__store__ = __webpack_require__(158);







__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vuex_router_sync__["sync"])(__WEBPACK_IMPORTED_MODULE_4__store__["a" /* default */], __WEBPACK_IMPORTED_MODULE_3__router__["a" /* default */]);

__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].config.productionTip = true;

new __WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */]({
  el: '#app',
  router: __WEBPACK_IMPORTED_MODULE_3__router__["a" /* default */],
  store: __WEBPACK_IMPORTED_MODULE_4__store__["a" /* default */],
  template: '<App/>',
  components: { App: __WEBPACK_IMPORTED_MODULE_2__App___default.a }
});

/***/ })
],[300]);


// WEBPACK FOOTER //
// static/js/app.bf1ff436910ef14e56bb.js